export const VN_ADDRESS = {
  "AN GIANG": [
    "BINH DUC WARD",
    "CHI LANG WARD",
    "CHAU DOC WARD",
    "HA TIEN WARD",
    "LONG PHU WARD",
    "LONG XUYEN WARD",
    "MY THOI WARD",
    "RACH GIA WARD",
    "THOI SON WARD",
    "TAN CHAU WARD",
    "TO CHAU WARD",
    "TINH BIEN WARD",
    "VINH THONG WARD",
    "VINH TE WARD",
    "AN BIEN COMMUNE",
    "AN CHAU COMMUNE",
    "AN CU COMMUNE",
    "AN MINH COMMUNE",
    "AN PHU COMMUNE",
    "BA CHUC COMMUNE",
    "BINH AN COMMUNE",
    "BINH GIANG COMMUNE",
    "BINH HOA COMMUNE",
    "BINH MY COMMUNE",
    "BINH SON COMMUNE",
    "BINH THANH DONG COMMUNE",
    "CHAU PHONG COMMUNE",
    "CHAU PHU COMMUNE",
    "CHAU THANH COMMUNE",
    "CHO MOI COMMUNE",
    "CHO VAM COMMUNE",
    "CO TO COMMUNE",
    "CU LAO GIENG COMMUNE",
    "CAN DANG COMMUNE",
    "GIANG THANH COMMUNE",
    "GIONG RIENG COMMUNE",
    "GO QUAO COMMUNE",
    "HOA HUNG COMMUNE",
    "HOA LAC COMMUNE",
    "HOA THUAN COMMUNE",
    "HOA DIEN COMMUNE",
    "HON NGHE COMMUNE",
    "HON DAT COMMUNE",
    "HOI AN COMMUNE",
    "KHANH BINH COMMUNE",
    "KIEN LUONG COMMUNE",
    "LONG KIEN COMMUNE",
    "LONG THANH COMMUNE",
    "LONG DIEN COMMUNE",
    "MY HOA HUNG COMMUNE",
    "MY THUAN COMMUNE",
    "MY DUC COMMUNE",
    "NGOC CHUC COMMUNE",
    "NHON HOI COMMUNE",
    "NHON MY COMMUNE",
    "NUI CAM COMMUNE",
    "PHU AN COMMUNE",
    "PHU HOA COMMUNE",
    "PHU HUU COMMUNE",
    "PHU LAM COMMUNE",
    "PHU TAN COMMUNE",
    "SON HAI COMMUNE",
    "SON KIEN COMMUNE",
    "THOAI SON COMMUNE",
    "THANH HUNG COMMUNE",
    "THANH LOC COMMUNE",
    "THANH MY TAY COMMUNE",
    "THANH DONG COMMUNE",
    "TIEN HAI COMMUNE",
    "TRI TON COMMUNE",
    "TAN AN COMMUNE",
    "TAN HIEP COMMUNE",
    "TAN HOI COMMUNE",
    "TAN THANH COMMUNE",
    "TAY PHU COMMUNE",
    "TAY YEN COMMUNE",
    "U MINH THUONG COMMUNE",
    "VAN KHANH COMMUNE",
    "VINH AN COMMUNE",
    "VINH BINH COMMUNE",
    "VINH GIA COMMUNE",
    "VINH HANH COMMUNE",
    "VINH HOA COMMUNE",
    "VINH HOA HUNG COMMUNE",
    "VINH HAU COMMUNE",
    "VINH PHONG COMMUNE",
    "VINH THUAN COMMUNE",
    "VINH THANH TRUNG COMMUNE",
    "VINH TRACH COMMUNE",
    "VINH TUY COMMUNE",
    "VINH XUONG COMMUNE",
    "VINH DIEU COMMUNE",
    "OC EO COMMUNE",
    "O LAM COMMUNE",
    "DONG HOA COMMUNE",
    "DONG HUNG COMMUNE",
    "DONG THAI COMMUNE",
    "DINH HOA COMMUNE",
    "DINH MY COMMUNE",
    "DAC KHU KIEN HAI",
    "DAC KHU PHU QUOC",
    "DAC KHU THO CHAU"
  ],
  "BAC NINH": [
    "BAC GIANG WARD",
    "BONG LAI WARD",
    "CHU WARD",
    "CANH THUY WARD",
    "HAP LINH WARD",
    "KINH BAC WARD",
    "MAO DIEN WARD",
    "NAM SON WARD",
    "NHAN HOA WARD",
    "NINH XA WARD",
    "NENH WARD",
    "PHU KHE WARD",
    "PHUONG LIEU WARD",
    "PHUONG SON WARD",
    "QUE VO WARD",
    "SONG LIEU WARD",
    "TAM SON WARD",
    "THUAN THANH WARD",
    "TIEN PHONG WARD",
    "TRI QUA WARD",
    "TRAM LO WARD",
    "TAN AN WARD",
    "TAN TIEN WARD",
    "TU SON WARD",
    "TU LAN WARD",
    "VIET YEN WARD",
    "VAN HA WARD",
    "VO CUONG WARD",
    "VU NINH WARD",
    "YEN DUNG WARD",
    "DA MAI WARD",
    "DAO VIEN WARD",
    "DONG NGUYEN WARD",
    "AN LAC COMMUNE",
    "BIEN SON COMMUNE",
    "BIEN DONG COMMUNE",
    "BAO DAI COMMUNE",
    "BAC LUNG COMMUNE",
    "BO HA COMMUNE",
    "CAO DUC COMMUNE",
    "CHI LANG COMMUNE",
    "CAM LY COMMUNE",
    "DUONG HUU COMMUNE",
    "GIA BINH COMMUNE",
    "HIEP HOA COMMUNE",
    "HOANG VAN COMMUNE",
    "HOP THINH COMMUNE",
    "KIEN LAO COMMUNE",
    "KEP COMMUNE",
    "LIEN BAO COMMUNE",
    "LAM THAO COMMUNE",
    "LUONG TAI COMMUNE",
    "LANG GIANG COMMUNE",
    "LUC NAM COMMUNE",
    "LUC NGAN COMMUNE",
    "LUC SON COMMUNE",
    "MY THAI COMMUNE",
    "NAM DUONG COMMUNE",
    "NGHIA PHUONG COMMUNE",
    "NGOC THIEN COMMUNE",
    "NHAN THANG COMMUNE",
    "NHA NAM COMMUNE",
    "PHU LANG COMMUNE",
    "PHUC HOA COMMUNE",
    "PHAT TICH COMMUNE",
    "QUANG TRUNG COMMUNE",
    "SA LY COMMUNE",
    "SON HAI COMMUNE",
    "SON DONG COMMUNE",
    "TAM GIANG COMMUNE",
    "TAM TIEN COMMUNE",
    "TAM DA COMMUNE",
    "TIEN DU COMMUNE",
    "TIEN LUC COMMUNE",
    "TRUNG CHINH COMMUNE",
    "TRUNG KENH COMMUNE",
    "TRUONG SON COMMUNE",
    "TUAN DAO COMMUNE",
    "TAN CHI COMMUNE",
    "TAN DINH COMMUNE",
    "TAN SON COMMUNE",
    "TAN YEN COMMUNE",
    "TAY YEN TU COMMUNE",
    "VAN SON COMMUNE",
    "VAN MON COMMUNE",
    "XUAN CAM COMMUNE",
    "XUAN LUONG COMMUNE",
    "YEN PHONG COMMUNE",
    "YEN THE COMMUNE",
    "YEN TRUNG COMMUNE",
    "YEN DINH COMMUNE",
    "DEO GIA COMMUNE",
    "DONG CUU COMMUNE",
    "DONG PHU COMMUNE",
    "DAI LAI COMMUNE",
    "DAI SON COMMUNE",
    "DAI DONG COMMUNE",
    "DONG KY COMMUNE",
    "DONG VIET COMMUNE"
  ],
  "CAO BANG": [
    "NUNG TRI CAO WARD",
    "THUC PHAN WARD",
    "TAN GIANG WARD",
    "BACH DANG COMMUNE",
    "BAO LAM COMMUNE",
    "BAO LAC COMMUNE",
    "BE VAN DAN COMMUNE",
    "CA THANH COMMUNE",
    "CANH TAN COMMUNE",
    "CO BA COMMUNE",
    "CAN YEN COMMUNE",
    "COC PANG COMMUNE",
    "HUY GIAP COMMUNE",
    "HA QUANG COMMUNE",
    "HOA AN COMMUNE",
    "HUNG DAO COMMUNE",
    "HA LANG COMMUNE",
    "HANH PHUC COMMUNE",
    "KHANH XUAN COMMUNE",
    "KIM DONG COMMUNE",
    "LY BON COMMUNE",
    "LY QUOC COMMUNE",
    "LUNG NAM COMMUNE",
    "MINH KHAI COMMUNE",
    "MINH TAM COMMUNE",
    "NAM QUANG COMMUNE",
    "NAM TUAN COMMUNE",
    "NGUYEN BINH COMMUNE",
    "NGUYEN HUE COMMUNE",
    "PHAN THANH COMMUNE",
    "PHUC HOA COMMUNE",
    "QUANG HAN COMMUNE",
    "QUANG LONG COMMUNE",
    "QUANG TRUNG COMMUNE",
    "QUANG LAM COMMUNE",
    "QUANG UYEN COMMUNE",
    "SON LO COMMUNE",
    "TAM KIM COMMUNE",
    "THANH LONG COMMUNE",
    "THANH CONG COMMUNE",
    "THONG NONG COMMUNE",
    "THACH AN COMMUNE",
    "TRA LINH COMMUNE",
    "TRUNG KHANH COMMUNE",
    "TRUONG HA COMMUNE",
    "TINH TUC COMMUNE",
    "TONG COT COMMUNE",
    "VINH QUY COMMUNE",
    "XUAN TRUONG COMMUNE",
    "YEN THO COMMUNE",
    "DOAI DUONG COMMUNE",
    "DAM THUY COMMUNE",
    "DINH PHONG COMMUNE",
    "DONG KHE COMMUNE",
    "DOC LAP COMMUNE",
    "DUC LONG COMMUNE"
  ],
  "CA MAU": [
    "AN XUYEN WARD",
    "BAC LIEU WARD",
    "GIA RAI WARD",
    "HIEP THANH WARD",
    "HOA THANH WARD",
    "LANG TRON WARD",
    "LY VAN LAM WARD",
    "TAN THANH WARD",
    "VINH TRACH WARD",
    "AN TRACH COMMUNE",
    "BIEN BACH COMMUNE",
    "CHAU THOI COMMUNE",
    "CAI NUOC COMMUNE",
    "CAI DOI VAM COMMUNE",
    "GANH HAO COMMUNE",
    "HOA BINH COMMUNE",
    "HUNG HOI COMMUNE",
    "HUNG MY COMMUNE",
    "HO THI KY COMMUNE",
    "HONG DAN COMMUNE",
    "KHANH AN COMMUNE",
    "KHANH BINH COMMUNE",
    "KHANH HUNG COMMUNE",
    "KHANH LAM COMMUNE",
    "LONG DIEN COMMUNE",
    "LUONG THE TRAN COMMUNE",
    "NGUYEN PHICH COMMUNE",
    "NGUYEN VIET KHAI COMMUNE",
    "NINH QUOI COMMUNE",
    "NINH THANH LOI COMMUNE",
    "NAM CAN COMMUNE",
    "PHAN NGOC HIEN COMMUNE",
    "PHONG HIEP COMMUNE",
    "PHONG THANH COMMUNE",
    "PHU MY COMMUNE",
    "PHU TAN COMMUNE",
    "PHUOC LONG COMMUNE",
    "QUACH PHAM COMMUNE",
    "SONG DOC COMMUNE",
    "TAM GIANG COMMUNE",
    "THANH TUNG COMMUNE",
    "THOI BINH COMMUNE",
    "TRI PHAI COMMUNE",
    "TRAN PHAN COMMUNE",
    "TRAN VAN THOI COMMUNE",
    "TAN HUNG COMMUNE",
    "TAN LOC COMMUNE",
    "TAN THUAN COMMUNE",
    "TAN TIEN COMMUNE",
    "TAN AN COMMUNE",
    "TA AN KHUONG COMMUNE",
    "U MINH COMMUNE",
    "VINH HAU COMMUNE",
    "VINH LOC COMMUNE",
    "VINH LOI COMMUNE",
    "VINH MY COMMUNE",
    "VINH PHUOC COMMUNE",
    "VINH THANH COMMUNE",
    "DA BAC COMMUNE",
    "DONG HAI COMMUNE",
    "DAT MUI COMMUNE",
    "DAT MOI COMMUNE",
    "DAM DOI COMMUNE",
    "DINH THANH COMMUNE"
  ],
  "GIA LAI": [
    "AN BINH WARD",
    "AN KHE WARD",
    "AN NHON WARD",
    "AN NHON BAC WARD",
    "AN NHON NAM WARD",
    "AN NHON DONG WARD",
    "AN PHU WARD",
    "AYUN PA WARD",
    "BINH DINH WARD",
    "BONG SON WARD",
    "DIEN HONG WARD",
    "HOAI NHON WARD",
    "HOAI NHON BAC WARD",
    "HOAI NHON NAM WARD",
    "HOAI NHON TAY WARD",
    "HOAI NHON DONG WARD",
    "HOI PHU WARD",
    "PLEIKU WARD",
    "QUY NHON WARD",
    "QUY NHON BAC WARD",
    "QUY NHON NAM WARD",
    "QUY NHON TAY WARD",
    "QUY NHON DONG WARD",
    "TAM QUAN WARD",
    "THONG NHAT WARD",
    "ALBA COMMUNE",
    "AN HOA COMMUNE",
    "AN LAO COMMUNE",
    "AN LUONG COMMUNE",
    "AN NHON TAY COMMUNE",
    "AN TOAN COMMUNE",
    "AN VINH COMMUNE",
    "AYUN COMMUNE",
    "BIEN HO COMMUNE",
    "BAU CAN COMMUNE",
    "BINH AN COMMUNE",
    "BINH DUONG COMMUNE",
    "BINH HIEP COMMUNE",
    "BINH KHE COMMUNE",
    "BINH PHU COMMUNE",
    "BO NGOONG COMMUNE",
    "CANH LIEN COMMUNE",
    "CANH VINH COMMUNE",
    "CHO LONG COMMUNE",
    "CHU A THAI COMMUNE",
    "CHU KREY COMMUNE",
    "CHU PRONG COMMUNE",
    "CHU PAH COMMUNE",
    "CHU PUH COMMUNE",
    "CHU SE COMMUNE",
    "CAT TIEN COMMUNE",
    "CUU AN COMMUNE",
    "GAO COMMUNE",
    "HOAI AN COMMUNE",
    "HRA COMMUNE",
    "HOA HOI COMMUNE",
    "HOI SON COMMUNE",
    "IA BOONG COMMUNE",
    "IA BANG COMMUNE",
    "IA CHIA COMMUNE",
    "IA DOM COMMUNE",
    "IA DREH COMMUNE",
    "IA DOK COMMUNE",
    "IA GRAI COMMUNE",
    "IA HIAO COMMUNE",
    "IA HRUNG COMMUNE",
    "IA HRU COMMUNE",
    "IA KHUOL COMMUNE",
    "IA KO COMMUNE",
    "IA KRAI COMMUNE",
    "IA KREL COMMUNE",
    "IA LE COMMUNE",
    "IA LY COMMUNE",
    "IA LAU COMMUNE",
    "IA MO COMMUNE",
    "IA NAN COMMUNE",
    "IA O COMMUNE",
    "IA PA COMMUNE",
    "IA PHI COMMUNE",
    "IA PIA COMMUNE",
    "IA PNON COMMUNE",
    "IA PUCH COMMUNE",
    "IA RBOL COMMUNE",
    "IA RSAI COMMUNE",
    "IA SAO COMMUNE",
    "IA TUL COMMUNE",
    "IA TOR COMMUNE",
    "KDANG COMMUNE",
    "KBANG COMMUNE",
    "KIM SON COMMUNE",
    "KON CHIENG COMMUNE",
    "KON GANG COMMUNE",
    "KRONG COMMUNE",
    "KONG BO LA COMMUNE",
    "KONG CHRO COMMUNE",
    "LO PANG COMMUNE",
    "MANG YANG COMMUNE",
    "NGO MAY COMMUNE",
    "NHON CHAU COMMUNE",
    "PHU CAT COMMUNE",
    "PHU MY COMMUNE",
    "PHU MY BAC COMMUNE",
    "PHU MY NAM COMMUNE",
    "PHU MY TAY COMMUNE",
    "PHU MY DONG COMMUNE",
    "PHU THIEN COMMUNE",
    "PHU TUC COMMUNE",
    "PO TO COMMUNE",
    "SRO COMMUNE",
    "SON LANG COMMUNE",
    "TUY PHUOC COMMUNE",
    "TUY PHUOC BAC COMMUNE",
    "TUY PHUOC TAY COMMUNE",
    "TUY PHUOC DONG COMMUNE",
    "TAY SON COMMUNE",
    "TO TUNG COMMUNE",
    "UAR COMMUNE",
    "VAN CANH COMMUNE",
    "VINH QUANG COMMUNE",
    "VINH SON COMMUNE",
    "VINH THANH COMMUNE",
    "VINH THINH COMMUNE",
    "VAN DUC COMMUNE",
    "XUAN AN COMMUNE",
    "YA HOI COMMUNE",
    "YA MA COMMUNE",
    "AN HAO COMMUNE",
    "AN TUONG COMMUNE",
    "DAK PO COMMUNE",
    "DAK RONG COMMUNE",
    "DAK SOMEI COMMUNE",
    "DAK DOA COMMUNE",
    "DAK SONG COMMUNE",
    "DE GI COMMUNE",
    "DUC CO COMMUNE"
  ],
  "HA TINH": [
    "BAC HONG LINH WARD",
    "HOANH SON WARD",
    "HA HUY TAP WARD",
    "HAI NINH WARD",
    "NAM HONG LINH WARD",
    "SONG TRI WARD",
    "THANH SEN WARD",
    "TRAN PHU WARD",
    "VUNG ANG WARD",
    "CAN LOC COMMUNE",
    "CAM BINH COMMUNE",
    "CAM DUE COMMUNE",
    "CAM HUNG COMMUNE",
    "CAM LAC COMMUNE",
    "CAM TRUNG COMMUNE",
    "CAM XUYEN COMMUNE",
    "CO DAM COMMUNE",
    "GIA HANH COMMUNE",
    "HA LINH COMMUNE",
    "HUONG BINH COMMUNE",
    "HUONG KHE COMMUNE",
    "HUONG PHO COMMUNE",
    "HUONG SON COMMUNE",
    "HUONG XUAN COMMUNE",
    "HUONG DO COMMUNE",
    "HONG LOC COMMUNE",
    "KIM HOA COMMUNE",
    "KY ANH COMMUNE",
    "KY HOA COMMUNE",
    "KY KHANG COMMUNE",
    "KY LAC COMMUNE",
    "KY THUONG COMMUNE",
    "KY VAN COMMUNE",
    "KY XUAN COMMUNE",
    "LOC HA COMMUNE",
    "MAI HOA COMMUNE",
    "MAI PHU COMMUNE",
    "NGHI XUAN COMMUNE",
    "PHUC TRACH COMMUNE",
    "SON GIANG COMMUNE",
    "SON HONG COMMUNE",
    "SON KIM 1 COMMUNE",
    "SON KIM 2 COMMUNE",
    "SON TIEN COMMUNE",
    "SON TAY COMMUNE",
    "THIEN CAM COMMUNE",
    "THUONG DUC COMMUNE",
    "THACH HA COMMUNE",
    "THACH KHE COMMUNE",
    "THACH LAC COMMUNE",
    "THACH XUAN COMMUNE",
    "TIEN DIEN COMMUNE",
    "TOAN LUU COMMUNE",
    "TRUONG LUU COMMUNE",
    "TUNG LOC COMMUNE",
    "TU MY COMMUNE",
    "VIET XUYEN COMMUNE",
    "VU QUANG COMMUNE",
    "XUAN LOC COMMUNE",
    "YEN HOA COMMUNE",
    "DAN HAI COMMUNE",
    "DONG KINH COMMUNE",
    "DONG LOC COMMUNE",
    "DONG TIEN COMMUNE",
    "DUC MINH COMMUNE",
    "DUC QUANG COMMUNE",
    "DUC THINH COMMUNE",
    "DUC THO COMMUNE",
    "DUC DONG COMMUNE"
  ],
  "HUNG YEN": [
    "HONG CHAU WARD",
    "MY HAO WARD",
    "PHO HIEN WARD",
    "SON NAM WARD",
    "THAI BINH WARD",
    "THUONG HONG WARD",
    "TRA LY WARD",
    "TRAN HUNG DAO WARD",
    "TRAN LAM WARD",
    "VU PHUC WARD",
    "DUONG HAO WARD",
    "BAC DONG QUAN COMMUNE",
    "A SAO COMMUNE",
    "BINH NGUYEN COMMUNE",
    "BINH THANH COMMUNE",
    "BINH DINH COMMUNE",
    "BAC THAI NINH COMMUNE",
    "BAC THUY ANH COMMUNE",
    "BAC TIEN HUNG COMMUNE",
    "BAC DONG HUNG COMMUNE",
    "CHAU NINH COMMUNE",
    "CHI MINH COMMUNE",
    "DIEN HA COMMUNE",
    "HIEP CUONG COMMUNE",
    "HOAN LONG COMMUNE",
    "HOANG HOA THAM COMMUNE",
    "HUNG HA COMMUNE",
    "HUNG PHU COMMUNE",
    "HONG MINH COMMUNE",
    "HONG QUANG COMMUNE",
    "HONG VU COMMUNE",
    "KHOAI CHAU COMMUNE",
    "KIEN XUONG COMMUNE",
    "LONG HUNG COMMUNE",
    "LE LOI COMMUNE",
    "LE QUY DON COMMUNE",
    "LUONG BANG COMMUNE",
    "LAC DAO COMMUNE",
    "MINH THO COMMUNE",
    "ME SO COMMUNE",
    "NAM CUONG COMMUNE",
    "NAM THAI NINH COMMUNE",
    "NAM THUY ANH COMMUNE",
    "NAM TIEN HUNG COMMUNE",
    "NAM TIEN HAI COMMUNE",
    "NAM DONG HUNG COMMUNE",
    "NGHIA DAN COMMUNE",
    "NGHIA TRU COMMUNE",
    "NGUYEN DU COMMUNE",
    "NGUYEN TRAI COMMUNE",
    "NGUYEN VAN LINH COMMUNE",
    "NGOC LAM COMMUNE",
    "NGU THIEN COMMUNE",
    "NHU QUYNH COMMUNE",
    "PHAM NGU LAO COMMUNE",
    "PHU DUC COMMUNE",
    "PHUNG CONG COMMUNE",
    "QUANG HUNG COMMUNE",
    "QUANG LICH COMMUNE",
    "QUYNH AN COMMUNE",
    "QUYNH PHU COMMUNE",
    "THAI NINH COMMUNE",
    "THAI THUY COMMUNE",
    "THU TRI COMMUNE",
    "THU VU COMMUNE",
    "THAN KHE COMMUNE",
    "THUY ANH COMMUNE",
    "TIEN HOA COMMUNE",
    "TIEN HUNG COMMUNE",
    "TIEN LA COMMUNE",
    "TIEN LU COMMUNE",
    "TIEN TIEN COMMUNE",
    "TIEN HAI COMMUNE",
    "TRIEU VIET VUONG COMMUNE",
    "TRA GIANG COMMUNE",
    "TAN HUNG COMMUNE",
    "TAN THUAN COMMUNE",
    "TAN TIEN COMMUNE",
    "TAY THAI NINH COMMUNE",
    "TAY THUY ANH COMMUNE",
    "TAY TIEN HAI COMMUNE",
    "TONG TRAN COMMUNE",
    "VIET TIEN COMMUNE",
    "VIET YEN COMMUNE",
    "VAN GIANG COMMUNE",
    "VU QUY COMMUNE",
    "VU THU COMMUNE",
    "VU TIEN COMMUNE",
    "VAN XUAN COMMUNE",
    "XUAN TRUC COMMUNE",
    "YEN MY COMMUNE",
    "AI QUOC COMMUNE",
    "AN THI COMMUNE",
    "DOAN DAO COMMUNE",
    "DONG HUNG COMMUNE",
    "DONG QUAN COMMUNE",
    "DONG THAI NINH COMMUNE",
    "DONG THUY ANH COMMUNE",
    "DONG TIEN HUNG COMMUNE",
    "DONG TIEN HAI COMMUNE",
    "DAI DONG COMMUNE",
    "DONG BANG COMMUNE",
    "DONG CHAU COMMUNE",
    "DUC HOP COMMUNE"
  ],
  "KHANH HOA": [
    "PHUONG HOA THANG",
    "PHUONG DONG NINH HOA",
    "BA NGOI WARD",
    "BAO AN WARD",
    "BAC CAM RANH WARD",
    "BAC NHA TRANG WARD",
    "CAM LINH WARD",
    "CAM RANH WARD",
    "NAM NHA TRANG WARD",
    "NHA TRANG WARD",
    "NINH CHU WARD",
    "NINH HOA WARD",
    "PHAN RANG WARD",
    "TAY NHA TRANG WARD",
    "DO VINH WARD",
    "DONG HAI WARD",
    "XA HOA TRI",
    "XA NAM NINH HOA",
    "XA TAY NINH HOA",
    "ANH DUNG COMMUNE",
    "BAC AI COMMUNE",
    "BAC AI TAY COMMUNE",
    "BAC AI DONG COMMUNE",
    "BAC KHANH VINH COMMUNE",
    "BAC NINH HOA COMMUNE",
    "CAM AN COMMUNE",
    "CAM HIEP COMMUNE",
    "CAM LAM COMMUNE",
    "CA NA COMMUNE",
    "CONG HAI COMMUNE",
    "DIEN KHANH COMMUNE",
    "DIEN LAM COMMUNE",
    "DIEN LAC COMMUNE",
    "DIEN THO COMMUNE",
    "DIEN DIEN COMMUNE",
    "KHANH SON COMMUNE",
    "KHANH VINH COMMUNE",
    "LAM SON COMMUNE",
    "MY SON COMMUNE",
    "NAM CAM RANH COMMUNE",
    "NAM KHANH VINH COMMUNE",
    "NINH HAI COMMUNE",
    "NINH PHUOC COMMUNE",
    "NINH SON COMMUNE",
    "PHUOC DINH COMMUNE",
    "PHUOC HA COMMUNE",
    "PHUOC HAU COMMUNE",
    "PHUOC HUU COMMUNE",
    "SUOI DAU COMMUNE",
    "SUOI HIEP COMMUNE",
    "THUAN BAC COMMUNE",
    "THUAN NAM COMMUNE",
    "TRUNG KHANH VINH COMMUNE",
    "TU BONG COMMUNE",
    "TAN DINH COMMUNE",
    "TAY KHANH SON COMMUNE",
    "TAY KHANH VINH COMMUNE",
    "VINH HAI COMMUNE",
    "VAN HUNG COMMUNE",
    "VAN NINH COMMUNE",
    "VAN THANG COMMUNE",
    "XUAN HAI COMMUNE",
    "DONG KHANH SON COMMUNE",
    "DAI LANH COMMUNE",
    "DAC KHU TRUONG SA"
  ],
  "LAI CHAU": [
    "TAN PHONG WARD",
    "DOAN KET WARD",
    "BUM NUA COMMUNE",
    "BUM TO COMMUNE",
    "BINH LU COMMUNE",
    "BAN BO COMMUNE",
    "DAO SAN COMMUNE",
    "HUA BUM COMMUNE",
    "HONG THU COMMUNE",
    "KHOEN ON COMMUNE",
    "KHUN HA COMMUNE",
    "KHONG LAO COMMUNE",
    "LE LOI COMMUNE",
    "MU CA COMMUNE",
    "MUONG KHOA COMMUNE",
    "MUONG KIM COMMUNE",
    "MUONG MO COMMUNE",
    "MUONG THAN COMMUNE",
    "MUONG TE COMMUNE",
    "NAM CUOI COMMUNE",
    "NAM HANG COMMUNE",
    "NAM MA COMMUNE",
    "NAM SO COMMUNE",
    "NAM TAM COMMUNE",
    "PA TAN COMMUNE",
    "PA U COMMUNE",
    "PHONG THO COMMUNE",
    "PU SAM CAP COMMUNE",
    "PAC TA COMMUNE",
    "SIN SUOI HO COMMUNE",
    "SI LO LAU COMMUNE",
    "SIN HO COMMUNE",
    "THAN UYEN COMMUNE",
    "THU LUM COMMUNE",
    "TA TONG COMMUNE",
    "TAN UYEN COMMUNE",
    "TA LENG COMMUNE",
    "TUA SIN CHAI COMMUNE"
  ],
  "LAO CAI": [
    "CAM DUONG WARD",
    "CAU THIA WARD",
    "LAO CAI WARD",
    "NAM CUONG WARD",
    "NGHIA LO WARD",
    "SA PA WARD",
    "TRUNG TAM WARD",
    "VAN PHU WARD",
    "YEN BAI WARD",
    "AU LAU WARD",
    "XA KHANH HOA",
    "XA LUONG THINH",
    "XA MO VANG",
    "XA MUONG LAI",
    "XA THUONG BANG LA",
    "XA TU LE",
    "A MU SUNG COMMUNE",
    "BAT XAT COMMUNE",
    "BAN HO COMMUNE",
    "BAN LIEN COMMUNE",
    "BAN LAU COMMUNE",
    "BAN XEO COMMUNE",
    "BAO HA COMMUNE",
    "BAO NHAI COMMUNE",
    "BAO THANG COMMUNE",
    "BAO YEN COMMUNE",
    "BAO AI COMMUNE",
    "BAC HA COMMUNE",
    "CAO SON COMMUNE",
    "CHIENG KEN COMMUNE",
    "CHAU QUE COMMUNE",
    "CHAN THINH COMMUNE",
    "CHE TAO COMMUNE",
    "CAT THINH COMMUNE",
    "CAM NHAN COMMUNE",
    "COC LAU COMMUNE",
    "COC SAN COMMUNE",
    "DUONG QUY COMMUNE",
    "DEN SANG COMMUNE",
    "GIA HOI COMMUNE",
    "GIA PHU COMMUNE",
    "HUNG KHANH COMMUNE",
    "HANH PHUC COMMUNE",
    "HOP THANH COMMUNE",
    "KHAO MANG COMMUNE",
    "KHANH YEN COMMUNE",
    "LAO CHAI COMMUNE",
    "LIEN SON COMMUNE",
    "LAM GIANG COMMUNE",
    "LAM THUONG COMMUNE",
    "LUNG PHINH COMMUNE",
    "LUC YEN COMMUNE",
    "MINH LUONG COMMUNE",
    "MU CANG CHAI COMMUNE",
    "MUONG BO COMMUNE",
    "MUONG HUM COMMUNE",
    "MUONG KHUONG COMMUNE",
    "MAU A COMMUNE",
    "NGHIA TAM COMMUNE",
    "NGHIA DO COMMUNE",
    "NGU CHI SON COMMUNE",
    "NAM CHAY COMMUNE",
    "NAM CO COMMUNE",
    "NAM XE COMMUNE",
    "PHA LONG COMMUNE",
    "PHONG DU HA COMMUNE",
    "PHONG DU THUONG COMMUNE",
    "PHONG HAI COMMUNE",
    "PHUC LOI COMMUNE",
    "PHINH HO COMMUNE",
    "PHUC KHANH COMMUNE",
    "PUNG LUONG COMMUNE",
    "QUY MONG COMMUNE",
    "SI MA CAI COMMUNE",
    "SIN CHENG COMMUNE",
    "SON LUONG COMMUNE",
    "THAC BA COMMUNE",
    "THUONG HA COMMUNE",
    "TRAM TAU COMMUNE",
    "TRAN YEN COMMUNE",
    "TRINH TUONG COMMUNE",
    "TA XI LANG COMMUNE",
    "TAN HOP COMMUNE",
    "TAN LINH COMMUNE",
    "TA CU TY COMMUNE",
    "TA PHIN COMMUNE",
    "TA VAN COMMUNE",
    "TANG LOONG COMMUNE",
    "VIET HONG COMMUNE",
    "VO LAO COMMUNE",
    "VAN BAN COMMUNE",
    "VAN CHAN COMMUNE",
    "XUAN AI COMMUNE",
    "XUAN HOA COMMUNE",
    "XUAN QUANG COMMUNE",
    "Y TY COMMUNE",
    "YEN BINH COMMUNE",
    "YEN THANH COMMUNE",
    "DONG CUONG COMMUNE"
  ],
  "LAM DONG": [
    "1 BAO LOC WARD",
    "2 BAO LOC WARD",
    "3 BAO LOC WARD",
    "B'LAO WARD",
    "BINH THUAN WARD",
    "BAC GIA NGHIA WARD",
    "CAM LY - DA LAT WARD",
    "HAM THANG WARD",
    "LA GI WARD",
    "LANG BIANG - DA LAT WARD",
    "LAM VIEN - DA LAT WARD",
    "MUI NE WARD",
    "NAM GIA NGHIA WARD",
    "PHAN THIET WARD",
    "PHU THUY WARD",
    "PHUOC HOI WARD",
    "TIEN THANH WARD",
    "XUAN HUONG - DA LAT WARD",
    "XUAN TRUONG - DA LAT WARD",
    "DONG GIA NGHIA WARD",
    "BAO LAM 1 COMMUNE",
    "BAO LAM 2 COMMUNE",
    "BAO LAM 3 COMMUNE",
    "BAO LAM 4 COMMUNE",
    "BAO LAM 5 COMMUNE",
    "BAO THUAN COMMUNE",
    "BAC BINH COMMUNE",
    "BAC RUONG COMMUNE",
    "CAT TIEN COMMUNE",
    "CAT TIEN 2 COMMUNE",
    "CAT TIEN 3 COMMUNE",
    "CU JUT COMMUNE",
    "D'RAN COMMUNE",
    "DI LINH COMMUNE",
    "GIA HIEP COMMUNE",
    "HIEP THANH COMMUNE",
    "HOAI DUC COMMUNE",
    "HAM KIEM COMMUNE",
    "HAM LIEM COMMUNE",
    "HAM THUAN COMMUNE",
    "HAM THUAN BAC COMMUNE",
    "HAM THUAN NAM COMMUNE",
    "HAM THANH COMMUNE",
    "HAM TAN COMMUNE",
    "HOA BAC COMMUNE",
    "HOA NINH COMMUNE",
    "HOA THANG COMMUNE",
    "HAI NINH COMMUNE",
    "HONG SON COMMUNE",
    "HONG THAI COMMUNE",
    "KA DO COMMUNE",
    "KIEN DUC COMMUNE",
    "KRONG NO COMMUNE",
    "LA DA COMMUNE",
    "LIEN HUONG COMMUNE",
    "LUONG SON COMMUNE",
    "LAC DUONG COMMUNE",
    "NAM BAN LAM HA COMMUNE",
    "NAM DONG COMMUNE",
    "NAM HA LAM HA COMMUNE",
    "NAM THANH COMMUNE",
    "NAM DA COMMUNE",
    "NGHI DUC COMMUNE",
    "NHAN CO COMMUNE",
    "NINH GIA COMMUNE",
    "NAM NUNG COMMUNE",
    "PHAN RI CUA COMMUNE",
    "PHAN SON COMMUNE",
    "PHU SON LAM HA COMMUNE",
    "PHUC THO LAM HA COMMUNE",
    "QUANG HOA COMMUNE",
    "QUANG KHE COMMUNE",
    "QUANG LAP COMMUNE",
    "QUANG PHU COMMUNE",
    "QUANG SON COMMUNE",
    "QUANG TRUC COMMUNE",
    "QUANG TAN COMMUNE",
    "QUANG TIN COMMUNE",
    "SUOI KIET COMMUNE",
    "SONG LUY COMMUNE",
    "SON MY COMMUNE",
    "SON DIEN COMMUNE",
    "THUAN AN COMMUNE",
    "THUAN HANH COMMUNE",
    "TRA TAN COMMUNE",
    "TRUONG XUAN COMMUNE",
    "TUY PHONG COMMUNE",
    "TUY DUC COMMUNE",
    "TUYEN QUANG COMMUNE",
    "TA HINE COMMUNE",
    "TA NANG COMMUNE",
    "TA DUNG COMMUNE",
    "TANH LINH COMMUNE",
    "TAN HA LAM HA COMMUNE",
    "TAN HAI COMMUNE",
    "TAN HOI COMMUNE",
    "TAN LAP COMMUNE",
    "TAN MINH COMMUNE",
    "TAN THANH COMMUNE",
    "VINH HAO COMMUNE",
    "DAM RONG 1 COMMUNE",
    "DAM RONG 2 COMMUNE",
    "DAM RONG 3 COMMUNE",
    "DAM RONG 4 COMMUNE",
    "DINH TRANG THUONG COMMUNE",
    "DINH VAN LAM HA COMMUNE",
    "DONG GIANG COMMUNE",
    "DON DUONG COMMUNE",
    "DA HUOAI COMMUNE",
    "DA HUOAI 2 COMMUNE",
    "DA HUOAI 3 COMMUNE",
    "DA TEH COMMUNE",
    "DA TEH 2 COMMUNE",
    "DA TEH 3 COMMUNE",
    "DAK MIL COMMUNE",
    "DAK SAK COMMUNE",
    "DAK WIL COMMUNE",
    "DAK SONG COMMUNE",
    "DONG KHO COMMUNE",
    "DUC AN COMMUNE",
    "DUC LINH COMMUNE",
    "DUC LAP COMMUNE",
    "DUC TRONG COMMUNE",
    "DAC KHU PHU QUY"
  ],
  "LANG SON": [
    "HOANG VAN THU WARD",
    "LUONG VAN TRI WARD",
    "TAM THANH WARD",
    "DONG KINH WARD",
    "BA SON COMMUNE",
    "BINH GIA COMMUNE",
    "BAC SON COMMUNE",
    "BANG MAC COMMUNE",
    "CAI KINH COMMUNE",
    "CAO LOC COMMUNE",
    "CHI LANG COMMUNE",
    "CHIEN THANG COMMUNE",
    "CHAU SON COMMUNE",
    "CONG SON COMMUNE",
    "HOA THAM COMMUNE",
    "HUNG VU COMMUNE",
    "HONG PHONG COMMUNE",
    "HOI HOAN COMMUNE",
    "HUU LIEN COMMUNE",
    "HUU LUNG COMMUNE",
    "KHUAT XA COMMUNE",
    "KHANG CHIEN COMMUNE",
    "KHANH KHE COMMUNE",
    "KIEN MOC COMMUNE",
    "LOC BINH COMMUNE",
    "LOI BAC COMMUNE",
    "MAU SON COMMUNE",
    "NA DUONG COMMUNE",
    "NA SAM COMMUNE",
    "NHAN LY COMMUNE",
    "NHAT HOA COMMUNE",
    "QUAN SON COMMUNE",
    "QUY HOA COMMUNE",
    "QUOC KHANH COMMUNE",
    "QUOC VIET COMMUNE",
    "THIEN HOA COMMUNE",
    "THIEN LONG COMMUNE",
    "THIEN THUAT COMMUNE",
    "THIEN TAN COMMUNE",
    "THAI BINH COMMUNE",
    "THAT KHE COMMUNE",
    "THONG NHAT COMMUNE",
    "THUY HUNG COMMUNE",
    "TRI LE COMMUNE",
    "TRANG DINH COMMUNE",
    "TUAN SON COMMUNE",
    "TAN THANH COMMUNE",
    "TAN TIEN COMMUNE",
    "TAN TRI COMMUNE",
    "TAN VAN COMMUNE",
    "TAN DOAN COMMUNE",
    "VAN NHAM COMMUNE",
    "VAN LANG COMMUNE",
    "VAN QUAN COMMUNE",
    "VU LANG COMMUNE",
    "VU LE COMMUNE",
    "VAN LINH COMMUNE",
    "XUAN DUONG COMMUNE",
    "YEN BINH COMMUNE",
    "YEN PHUC COMMUNE",
    "DIEM HE COMMUNE",
    "DOAN KET COMMUNE",
    "DINH LAP COMMUNE",
    "DONG DANG COMMUNE"
  ],
  "NGHE AN": [
    "CUA LO WARD",
    "HOANG MAI WARD",
    "QUYNH MAI WARD",
    "THANH VINH WARD",
    "THAI HOA WARD",
    "TRUONG VINH WARD",
    "TAN MAI WARD",
    "TAY HIEU WARD",
    "VINH HUNG WARD",
    "VINH LOC WARD",
    "VINH PHU WARD",
    "AN CHAU COMMUNE",
    "ANH SON COMMUNE",
    "ANH SON DONG COMMUNE",
    "BINH CHUAN COMMUNE",
    "BINH MINH COMMUNE",
    "BICH HAO COMMUNE",
    "BACH HA COMMUNE",
    "BACH NGOC COMMUNE",
    "BAC LY COMMUNE",
    "CAM PHUC COMMUNE",
    "CHIEU LUU COMMUNE",
    "CHAU BINH COMMUNE",
    "CHAU HONG COMMUNE",
    "CHAU KHE COMMUNE",
    "CHAU LOC COMMUNE",
    "CHAU TIEN COMMUNE",
    "CON CUONG COMMUNE",
    "CAT NGAN COMMUNE",
    "DIEN CHAU COMMUNE",
    "GIAI LAC COMMUNE",
    "GIAI XUAN COMMUNE",
    "HOA QUAN COMMUNE",
    "HUOI TU COMMUNE",
    "HUNG CHAN COMMUNE",
    "HUNG CHAU COMMUNE",
    "HUNG NGUYEN COMMUNE",
    "HUNG NGUYEN NAM COMMUNE",
    "HANH LAM COMMUNE",
    "HAI CHAU COMMUNE",
    "HAI LOC COMMUNE",
    "HOP MINH COMMUNE",
    "HUU KHUONG COMMUNE",
    "HUU KIEM COMMUNE",
    "KENG DU COMMUNE",
    "KIM BANG COMMUNE",
    "KIM LIEN COMMUNE",
    "LAM THANH COMMUNE",
    "LUONG SON COMMUNE",
    "LUONG MINH COMMUNE",
    "MINH CHAU COMMUNE",
    "MINH HOP COMMUNE",
    "MON SON COMMUNE",
    "MUONG CHONG COMMUNE",
    "MUONG HAM COMMUNE",
    "MUONG LONG COMMUNE",
    "MUONG QUANG COMMUNE",
    "MUONG TIP COMMUNE",
    "MUONG XEN COMMUNE",
    "MAU THACH COMMUNE",
    "MY LY COMMUNE",
    "NA LOI COMMUNE",
    "NA NGOI COMMUNE",
    "NAM DAN COMMUNE",
    "NGA MY COMMUNE",
    "NGHI LOC COMMUNE",
    "NGHIA HANH COMMUNE",
    "NGHIA HUNG COMMUNE",
    "NGHIA KHANH COMMUNE",
    "NGHIA LAM COMMUNE",
    "NGHIA LOC COMMUNE",
    "NGHIA MAI COMMUNE",
    "NGHIA THO COMMUNE",
    "NGHIA DAN COMMUNE",
    "NGHIA DONG COMMUNE",
    "NHAN HOA COMMUNE",
    "NHON MAI COMMUNE",
    "NAM CAN COMMUNE",
    "PHUC LOC COMMUNE",
    "QUAN THANH COMMUNE",
    "QUANG DONG COMMUNE",
    "QUANG CHAU COMMUNE",
    "QUE PHONG COMMUNE",
    "QUY CHAU COMMUNE",
    "QUY HOP COMMUNE",
    "QUYNH ANH COMMUNE",
    "QUYNH LUU COMMUNE",
    "QUYNH PHU COMMUNE",
    "QUYNH SON COMMUNE",
    "QUYNH TAM COMMUNE",
    "QUYNH THANG COMMUNE",
    "QUYNH VAN COMMUNE",
    "SON LAM COMMUNE",
    "TAM HOP COMMUNE",
    "TAM QUANG COMMUNE",
    "TAM THAI COMMUNE",
    "TAM DONG COMMUNE",
    "THIEN NHAN COMMUNE",
    "THUAN TRUNG COMMUNE",
    "THANH BINH THO COMMUNE",
    "THONG THU COMMUNE",
    "THAN LINH COMMUNE",
    "TIEN DONG COMMUNE",
    "TIEN PHONG COMMUNE",
    "TRI LE COMMUNE",
    "TRUNG LOC COMMUNE",
    "TAN AN COMMUNE",
    "TAN CHAU COMMUNE",
    "TAN KY COMMUNE",
    "TAN PHU COMMUNE",
    "TUONG DUONG COMMUNE",
    "VAN DU COMMUNE",
    "VAN TU COMMUNE",
    "VAN HIEN COMMUNE",
    "VAN KIEU COMMUNE",
    "VINH TUONG COMMUNE",
    "VAN AN COMMUNE",
    "XUAN LAM COMMUNE",
    "YEN HOA COMMUNE",
    "YEN NA COMMUNE",
    "YEN THANH COMMUNE",
    "YEN TRUNG COMMUNE",
    "YEN XUAN COMMUNE",
    "DO LUONG COMMUNE",
    "DONG HIEU COMMUNE",
    "DONG LOC COMMUNE",
    "DONG THANH COMMUNE",
    "DAI HUE COMMUNE",
    "DAI DONG COMMUNE",
    "DUC CHAU COMMUNE"
  ],
  "NINH BINH": [
    "CHAU SON WARD",
    "DUY HA WARD",
    "DUY TIEN WARD",
    "DUY TAN WARD",
    "HOA LU WARD",
    "HA NAM WARD",
    "HONG QUANG WARD",
    "KIM BANG WARD",
    "KIM THANH WARD",
    "LIEM TUYEN WARD",
    "LE HO WARD",
    "LY THUONG KIET WARD",
    "MY LOC WARD",
    "NAM HOA LU WARD",
    "NAM DINH WARD",
    "NGUYEN UY WARD",
    "PHU VAN WARD",
    "PHU LY WARD",
    "TAM CHUC WARD",
    "TAM DIEP WARD",
    "THIEN TRUONG WARD",
    "THANH NAM WARD",
    "TIEN SON WARD",
    "TRUNG SON WARD",
    "TRUONG THI WARD",
    "TAY HOA LU WARD",
    "VI KHE WARD",
    "YEN SON WARD",
    "YEN THANG WARD",
    "DONG A WARD",
    "DONG HOA LU WARD",
    "DONG VAN WARD",
    "XUAN GIANG COMMUNE",
    "BINH AN COMMUNE",
    "BINH GIANG COMMUNE",
    "BINH LUC COMMUNE",
    "BINH MINH COMMUNE",
    "BINH MY COMMUNE",
    "BINH SON COMMUNE",
    "BAC LY COMMUNE",
    "CHAT BINH COMMUNE",
    "CAT THANH COMMUNE",
    "CUC PHUONG COMMUNE",
    "CO LE COMMUNE",
    "GIA HUNG COMMUNE",
    "GIA LAM COMMUNE",
    "GIA PHONG COMMUNE",
    "GIA TRAN COMMUNE",
    "GIA TUONG COMMUNE",
    "GIA VIEN COMMUNE",
    "GIA VAN COMMUNE",
    "GIAO BINH COMMUNE",
    "GIAO HOA COMMUNE",
    "GIAO HUNG COMMUNE",
    "GIAO MINH COMMUNE",
    "GIAO NINH COMMUNE",
    "GIAO PHUC COMMUNE",
    "GIAO THUY COMMUNE",
    "HIEN KHANH COMMUNE",
    "HAI AN COMMUNE",
    "HAI ANH COMMUNE",
    "HAI HUNG COMMUNE",
    "HAI HAU COMMUNE",
    "HAI QUANG COMMUNE",
    "HAI THINH COMMUNE",
    "HAI TIEN COMMUNE",
    "HAI XUAN COMMUNE",
    "HONG PHONG COMMUNE",
    "KHANH HOI COMMUNE",
    "KHANH NHAC COMMUNE",
    "KHANH THIEN COMMUNE",
    "KHANH TRUNG COMMUNE",
    "KIM SON COMMUNE",
    "KIM DONG COMMUNE",
    "LAI THANH COMMUNE",
    "LIEM HA COMMUNE",
    "LIEN MINH COMMUNE",
    "LY NHAN COMMUNE",
    "MINH THAI COMMUNE",
    "MINH TAN COMMUNE",
    "NAM HONG COMMUNE",
    "NAM LY COMMUNE",
    "NAM MINH COMMUNE",
    "NAM NINH COMMUNE",
    "NAM TRUC COMMUNE",
    "NAM XANG COMMUNE",
    "NAM DONG COMMUNE",
    "NGHIA HUNG COMMUNE",
    "NGHIA LAM COMMUNE",
    "NGHIA SON COMMUNE",
    "NHO QUAN COMMUNE",
    "NHAN HA COMMUNE",
    "NINH CUONG COMMUNE",
    "NINH GIANG COMMUNE",
    "PHONG DOANH COMMUNE",
    "PHAT DIEM COMMUNE",
    "PHU LONG COMMUNE",
    "PHU SON COMMUNE",
    "QUANG HUNG COMMUNE",
    "QUANG THIEN COMMUNE",
    "QUYNH LUU COMMUNE",
    "QUY NHAT COMMUNE",
    "RANG DONG COMMUNE",
    "THANH BINH COMMUNE",
    "THANH LIEM COMMUNE",
    "THANH LAM COMMUNE",
    "THANH SON COMMUNE",
    "TRAN THUONG COMMUNE",
    "TRUC NINH COMMUNE",
    "TAN MINH COMMUNE",
    "TAN THANH COMMUNE",
    "VINH TRU COMMUNE",
    "VU DUONG COMMUNE",
    "VAN THANG COMMUNE",
    "VU BAN COMMUNE",
    "XUAN HUNG COMMUNE",
    "XUAN HONG COMMUNE",
    "XUAN TRUONG COMMUNE",
    "YEN CUONG COMMUNE",
    "YEN KHANH COMMUNE",
    "YEN MO COMMUNE",
    "YEN MAC COMMUNE",
    "YEN TU COMMUNE",
    "YEN DONG COMMUNE",
    "Y YEN COMMUNE",
    "DAI HOANG COMMUNE",
    "DINH HOA COMMUNE",
    "DONG THAI COMMUNE",
    "DONG THINH COMMUNE"
  ],
  "PHU THO": [
    "HOA BINH WARD",
    "KY SON WARD",
    "NONG TRANG WARD",
    "PHONG CHAU WARD",
    "PHU THO WARD",
    "PHUC YEN WARD",
    "THANH MIEU WARD",
    "THONG NHAT WARD",
    "TAN HOA WARD",
    "VIET TRI WARD",
    "VAN PHU WARD",
    "VINH PHUC WARD",
    "VINH YEN WARD",
    "XUAN HOA WARD",
    "AU CO WARD",
    "AN BINH COMMUNE",
    "AN NGHIA COMMUNE",
    "BAO LA COMMUNE",
    "BINH NGUYEN COMMUNE",
    "BINH PHU COMMUNE",
    "BINH TUYEN COMMUNE",
    "BINH XUYEN COMMUNE",
    "BAN NGUYEN COMMUNE",
    "BANG LUAN COMMUNE",
    "CAO DUONG COMMUNE",
    "CAO PHONG COMMUNE",
    "CAO SON COMMUNE",
    "CHAN MONG COMMUNE",
    "CHI TIEN COMMUNE",
    "CHI DAM COMMUNE",
    "CAM KHE COMMUNE",
    "CU DONG COMMUNE",
    "DAN CHU COMMUNE",
    "DUNG TIEN COMMUNE",
    "HIEN LUONG COMMUNE",
    "HIEN QUAN COMMUNE",
    "HOANG AN COMMUNE",
    "HOANG CUONG COMMUNE",
    "HY CUONG COMMUNE",
    "HUNG VIET COMMUNE",
    "HUONG CAN COMMUNE",
    "HA HOA COMMUNE",
    "HAI LUU COMMUNE",
    "HOI THINH COMMUNE",
    "HOP KIM COMMUNE",
    "HOP LY COMMUNE",
    "KHA CUU COMMUNE",
    "KIM BOI COMMUNE",
    "LAI DONG COMMUNE",
    "LIEN CHAU COMMUNE",
    "LIEN HOA COMMUNE",
    "LIEN MINH COMMUNE",
    "LIEN SON COMMUNE",
    "LONG COC COMMUNE",
    "LAM THAO COMMUNE",
    "LUONG SON COMMUNE",
    "LAC LUONG COMMUNE",
    "LAC SON COMMUNE",
    "LAC THUY COMMUNE",
    "LAP THACH COMMUNE",
    "MAI CHAU COMMUNE",
    "MAI HA COMMUNE",
    "MINH HOA COMMUNE",
    "MINH DAI COMMUNE",
    "MUONG BI COMMUNE",
    "MUONG HOA COMMUNE",
    "MUONG THANG COMMUNE",
    "MUONG VANG COMMUNE",
    "MUONG DONG COMMUNE",
    "NGUYET DUC COMMUNE",
    "NGOC SON COMMUNE",
    "NHAN NGHIA COMMUNE",
    "NAT SON COMMUNE",
    "PHU NINH COMMUNE",
    "PHUNG NGUYEN COMMUNE",
    "PHU KHE COMMUNE",
    "PHU MY COMMUNE",
    "PA CO COMMUNE",
    "QUY DUC COMMUNE",
    "QUYET THANG COMMUNE",
    "QUANG YEN COMMUNE",
    "SONG LO COMMUNE",
    "SON LUONG COMMUNE",
    "SON DONG COMMUNE",
    "TAM DUONG COMMUNE",
    "TAM DUONG BAC COMMUNE",
    "TAM HONG COMMUNE",
    "TAM NONG COMMUNE",
    "TAM SON COMMUNE",
    "TAM DAO COMMUNE",
    "THANH BA COMMUNE",
    "THANH SON COMMUNE",
    "THANH THUY COMMUNE",
    "THU CUC COMMUNE",
    "THUNG NAI COMMUNE",
    "THAI HOA COMMUNE",
    "THUONG COC COMMUNE",
    "THUONG LONG COMMUNE",
    "THINH MINH COMMUNE",
    "THO VAN COMMUNE",
    "THO TANG COMMUNE",
    "TIEN LUONG COMMUNE",
    "TIEN LU COMMUNE",
    "TIEN PHONG COMMUNE",
    "TOAN THANG COMMUNE",
    "TRUNG SON COMMUNE",
    "TRAM THAN COMMUNE",
    "TU VU COMMUNE",
    "TAN LAC COMMUNE",
    "TAN MAI COMMUNE",
    "TAN PHEO COMMUNE",
    "TAN SON COMMUNE",
    "TAY COC COMMUNE",
    "TE LO COMMUNE",
    "VAN BAN COMMUNE",
    "VAN SON COMMUNE",
    "VO MIEU COMMUNE",
    "VAN LANG COMMUNE",
    "VAN MIEU COMMUNE",
    "VINH AN COMMUNE",
    "VINH CHAN COMMUNE",
    "VINH HUNG COMMUNE",
    "VINH PHU COMMUNE",
    "VINH THANH COMMUNE",
    "VINH TUONG COMMUNE",
    "VAN XUAN COMMUNE",
    "XUAN LANG COMMUNE",
    "XUAN LUNG COMMUNE",
    "XUAN VIEN COMMUNE",
    "XUAN DAI COMMUNE",
    "YEN KY COMMUNE",
    "YEN LANG COMMUNE",
    "YEN LAC COMMUNE",
    "YEN LAP COMMUNE",
    "YEN PHU COMMUNE",
    "YEN SON COMMUNE",
    "YEN THUY COMMUNE",
    "YEN TRI COMMUNE",
    "DAN THUONG COMMUNE",
    "DOAN HUNG COMMUNE",
    "DA BAC COMMUNE",
    "DAO XA COMMUNE",
    "DONG THANH COMMUNE",
    "DAI DINH COMMUNE",
    "DAI DONG COMMUNE",
    "DAO TRU COMMUNE",
    "DONG LUONG COMMUNE",
    "DUC NHAN COMMUNE"
  ],
  "QUANG NGAI": [
    "CAM THANH WARD",
    "KON TUM WARD",
    "NGHIA LO WARD",
    "SA HUYNH WARD",
    "TRA CAU WARD",
    "TRUONG QUANG TRONG WARD",
    "DAK BLA WARD",
    "DAK CAM WARD",
    "DUC PHO WARD",
    "AN PHU COMMUNE",
    "BA DINH COMMUNE",
    "BA GIA COMMUNE",
    "BA TO COMMUNE",
    "BA VINH COMMUNE",
    "BA VI COMMUNE",
    "BA XA COMMUNE",
    "BA DONG COMMUNE",
    "BINH CHUONG COMMUNE",
    "BINH MINH COMMUNE",
    "BINH SON COMMUNE",
    "BO Y COMMUNE",
    "CA DAM COMMUNE",
    "DUC NONG COMMUNE",
    "IA CHIM COMMUNE",
    "IA TOI COMMUNE",
    "IA DAL COMMUNE",
    "KHANH CUONG COMMUNE",
    "KON BRAIH COMMUNE",
    "KON PLONG COMMUNE",
    "KON DAO COMMUNE",
    "LONG PHUNG COMMUNE",
    "LAN PHONG COMMUNE",
    "MINH LONG COMMUNE",
    "MO RAI COMMUNE",
    "MANG BUT COMMUNE",
    "MANG RI COMMUNE",
    "MANG DEN COMMUNE",
    "MO CAY COMMUNE",
    "MO DUC COMMUNE",
    "NGHIA GIANG COMMUNE",
    "NGHIA HANH COMMUNE",
    "NGUYEN NGHIEM COMMUNE",
    "NGOC LINH COMMUNE",
    "NGOK BAY COMMUNE",
    "NGOK REO COMMUNE",
    "NGOK TU COMMUNE",
    "PHUOC GIANG COMMUNE",
    "RO KOI COMMUNE",
    "SA BINH COMMUNE",
    "SA LOONG COMMUNE",
    "SA THAY COMMUNE",
    "SON HA COMMUNE",
    "SON KY COMMUNE",
    "SON LINH COMMUNE",
    "SON MAI COMMUNE",
    "SON THUY COMMUNE",
    "SON TAY COMMUNE",
    "SON TAY HA COMMUNE",
    "SON TAY THUONG COMMUNE",
    "SON TINH COMMUNE",
    "THANH BONG COMMUNE",
    "THIEN TIN COMMUNE",
    "THO PHONG COMMUNE",
    "TRA BONG COMMUNE",
    "TRA GIANG COMMUNE",
    "TRUONG GIANG COMMUNE",
    "TU MO RONG COMMUNE",
    "TAY TRA COMMUNE",
    "TAY TRA BONG COMMUNE",
    "TU NGHIA COMMUNE",
    "TINH KHE COMMUNE",
    "VAN TUONG COMMUNE",
    "VE GIANG COMMUNE",
    "XOP COMMUNE",
    "YA LY COMMUNE",
    "DINH CUONG COMMUNE",
    "DONG SON COMMUNE",
    "DONG TRA BONG COMMUNE",
    "DAK HA COMMUNE",
    "DAK KOI COMMUNE",
    "DAK LONG COMMUNE",
    "DAK MAR COMMUNE",
    "DAK MON COMMUNE",
    "DAK PLO COMMUNE",
    "DAK PXI COMMUNE",
    "DAK PEK COMMUNE",
    "DAK RVE COMMUNE",
    "DAK RO WA COMMUNE",
    "DAK SAO COMMUNE",
    "DAK TO COMMUNE",
    "DAK TO KAN COMMUNE",
    "DAK UI COMMUNE",
    "DANG THUY TRAM COMMUNE",
    "DAC KHU LY SON"
  ],
  "QUANG NINH": [
    "AN SINH WARD",
    "BAI CHAY WARD",
    "BINH KHE WARD",
    "CAO XANH WARD",
    "CAM PHA WARD",
    "CUA ONG WARD",
    "HIEP HOA WARD",
    "HOANG QUE WARD",
    "HOANH BO WARD",
    "HA AN WARD",
    "HA LAM WARD",
    "HA TU WARD",
    "HA LONG WARD",
    "HONG GAI WARD",
    "LIEN HOA WARD",
    "MONG CAI 1 WARD",
    "MONG CAI 2 WARD",
    "MONG CAI 3 WARD",
    "MONG DUONG WARD",
    "MAO KHE WARD",
    "PHONG COC WARD",
    "QUANG HANH WARD",
    "QUANG YEN WARD",
    "TUAN CHAU WARD",
    "UONG BI WARD",
    "VIET HUNG WARD",
    "VANG DANH WARD",
    "YEN TU WARD",
    "DONG MAI WARD",
    "DONG TRIEU WARD",
    "BA CHE COMMUNE",
    "BINH LIEU COMMUNE",
    "CAI CHIEN COMMUNE",
    "HOANH MO COMMUNE",
    "HAI HOA COMMUNE",
    "HAI LANG COMMUNE",
    "HAI NINH COMMUNE",
    "HAI SON COMMUNE",
    "KY THUONG COMMUNE",
    "LUONG MINH COMMUNE",
    "LUC HON COMMUNE",
    "QUANG HA COMMUNE",
    "QUANG LA COMMUNE",
    "QUANG TAN COMMUNE",
    "QUANG DUC COMMUNE",
    "THONG NHAT COMMUNE",
    "TIEN YEN COMMUNE",
    "VINH THUC COMMUNE",
    "DIEN XA COMMUNE",
    "DONG NGU COMMUNE",
    "DUONG HOA COMMUNE",
    "DAM HA COMMUNE",
    "DAC KHU CO TO",
    "DAC KHU VAN DON"
  ],
  "QUANG TRI": [
    "BA DON WARD",
    "BAC GIANH WARD",
    "NAM DONG HA WARD",
    "QUANG TRI WARD",
    "DONG HA WARD",
    "DONG HOI WARD",
    "DONG SON WARD",
    "DONG THUAN WARD",
    "A DOI COMMUNE",
    "BA LONG COMMUNE",
    "BAC TRACH COMMUNE",
    "BEN HAI COMMUNE",
    "BEN QUAN COMMUNE",
    "BO TRACH COMMUNE",
    "CAM HONG COMMUNE",
    "CAM LO COMMUNE",
    "CON TIEN COMMUNE",
    "CUA TUNG COMMUNE",
    "CUA VIET COMMUNE",
    "DIEN SANH COMMUNE",
    "DAN HOA COMMUNE",
    "GIO LINH COMMUNE",
    "HIEU GIANG COMMUNE",
    "HOAN LAO COMMUNE",
    "HOA TRACH COMMUNE",
    "HUONG HIEP COMMUNE",
    "HUONG LAP COMMUNE",
    "HUONG PHUNG COMMUNE",
    "HAI LANG COMMUNE",
    "KHE SANH COMMUNE",
    "KIM NGAN COMMUNE",
    "KIM PHU COMMUNE",
    "KIM DIEN COMMUNE",
    "LA LAY COMMUNE",
    "LAO BAO COMMUNE",
    "LIA COMMUNE",
    "LE NINH COMMUNE",
    "LE THUY COMMUNE",
    "MINH HOA COMMUNE",
    "MY THUY COMMUNE",
    "NAM BA DON COMMUNE",
    "NAM CUA VIET COMMUNE",
    "NAM GIANH COMMUNE",
    "NAM HAI LANG COMMUNE",
    "NAM TRACH COMMUNE",
    "NINH CHAU COMMUNE",
    "PHONG NHA COMMUNE",
    "PHU TRACH COMMUNE",
    "QUANG NINH COMMUNE",
    "QUANG TRACH COMMUNE",
    "SEN NGU COMMUNE",
    "THUONG TRACH COMMUNE",
    "TRIEU BINH COMMUNE",
    "TRIEU CO COMMUNE",
    "TRIEU PHONG COMMUNE",
    "TRUNG THUAN COMMUNE",
    "TRUONG NINH COMMUNE",
    "TRUONG PHU COMMUNE",
    "TRUONG SON COMMUNE",
    "TUYEN BINH COMMUNE",
    "TUYEN HOA COMMUNE",
    "TUYEN LAM COMMUNE",
    "TUYEN PHU COMMUNE",
    "TUYEN SON COMMUNE",
    "TA RUT COMMUNE",
    "TAN GIANH COMMUNE",
    "TAN LAP COMMUNE",
    "TAN MY COMMUNE",
    "TAN THANH COMMUNE",
    "VINH HOANG COMMUNE",
    "VINH LINH COMMUNE",
    "VINH THUY COMMUNE",
    "VINH DINH COMMUNE",
    "AI TU COMMUNE",
    "DAKRONG COMMUNE",
    "DONG TRACH COMMUNE",
    "DONG LE COMMUNE",
    "DAC KHU CON CO"
  ],
  "SON LA": [
    "CHIENG AN WARD",
    "CHIENG COI WARD",
    "CHIENG SINH WARD",
    "MOC CHAU WARD",
    "MOC SON WARD",
    "THAO NGUYEN WARD",
    "TO HIEU WARD",
    "VAN SON WARD",
    "BINH THUAN COMMUNE",
    "BO SINH COMMUNE",
    "BAC YEN COMMUNE",
    "CHIENG HOA COMMUNE",
    "CHIENG HAC COMMUNE",
    "CHIENG KHOONG COMMUNE",
    "CHIENG KHUONG COMMUNE",
    "CHIENG LA COMMUNE",
    "CHIENG LAO COMMUNE",
    "CHIENG MAI COMMUNE",
    "CHIENG MUNG COMMUNE",
    "CHIENG SUNG COMMUNE",
    "CHIENG SO COMMUNE",
    "CHIENG SON COMMUNE",
    "CHIENG SAI COMMUNE",
    "CO MA COMMUNE",
    "GIA PHU COMMUNE",
    "HUOI MOT COMMUNE",
    "KIM BON COMMUNE",
    "LONG HE COMMUNE",
    "LONG PHIENG COMMUNE",
    "LONG SAP COMMUNE",
    "MAI SON COMMUNE",
    "MUOI NOI COMMUNE",
    "MUONG BANG COMMUNE",
    "MUONG BAM COMMUNE",
    "MUONG BU COMMUNE",
    "MUONG CHANH COMMUNE",
    "MUONG CHIEN COMMUNE",
    "MUONG COI COMMUNE",
    "MUONG GION COMMUNE",
    "MUONG HUNG COMMUNE",
    "MUONG KHIENG COMMUNE",
    "MUONG LA COMMUNE",
    "MUONG LEO COMMUNE",
    "MUONG LAN COMMUNE",
    "MUONG LAM COMMUNE",
    "MUONG SAI COMMUNE",
    "MUONG E COMMUNE",
    "NGOC CHIEN COMMUNE",
    "NAM LAU COMMUNE",
    "NAM TY COMMUNE",
    "PHIENG CAM COMMUNE",
    "PHIENG KHOAI COMMUNE",
    "PHIENG PAN COMMUNE",
    "PHU YEN COMMUNE",
    "PUNG BANH COMMUNE",
    "PAC NGA COMMUNE",
    "QUYNH NHAI COMMUNE",
    "SONG KHUA COMMUNE",
    "SUOI TO COMMUNE",
    "SONG MA COMMUNE",
    "SOP COP COMMUNE",
    "THUAN CHAU COMMUNE",
    "TA HOC COMMUNE",
    "TA XUA COMMUNE",
    "TAN PHONG COMMUNE",
    "TAN YEN COMMUNE",
    "TO MUA COMMUNE",
    "TUONG HA COMMUNE",
    "TA KHOA COMMUNE",
    "VAN HO COMMUNE",
    "XUAN NHA COMMUNE",
    "XIM VANG COMMUNE",
    "YEN CHAU COMMUNE",
    "YEN SON COMMUNE",
    "DOAN KET COMMUNE"
  ],
  "CAN THO City": [
    "AN BINH WARD",
    "BINH THUY WARD",
    "CAI KHE WARD",
    "CAI RANG WARD",
    "HUNG PHU WARD",
    "KHANH HOA WARD",
    "LONG BINH WARD",
    "LONG MY WARD",
    "LONG PHU 1 WARD",
    "LONG TUYEN WARD",
    "MY QUOI WARD",
    "MY XUYEN WARD",
    "NGA BAY WARD",
    "NGA NAM WARD",
    "NINH KIEU WARD",
    "PHU LOI WARD",
    "PHUOC THOI WARD",
    "SOC TRANG WARD",
    "THUAN HUNG WARD",
    "THOT NOT WARD",
    "THOI AN DONG WARD",
    "THOI LONG WARD",
    "TRUNG NHUT WARD",
    "TAN AN WARD",
    "TAN LOC WARD",
    "VINH CHAU WARD",
    "VINH PHUOC WARD",
    "VI THANH WARD",
    "VI TAN WARD",
    "O MON WARD",
    "DAI THANH WARD",
    "PHU HUU COMMUNE",
    "DAI HAI COMMUNE",
    "AN LAC THON COMMUNE",
    "AN NINH COMMUNE",
    "AN THANH COMMUNE",
    "CHAU THANH COMMUNE",
    "CU LAO DUNG COMMUNE",
    "CO DO COMMUNE",
    "GIA HOA COMMUNE",
    "HIEP HUNG COMMUNE",
    "HOA AN COMMUNE",
    "HOA TU COMMUNE",
    "HOA LUU COMMUNE",
    "HO DAC KIEN COMMUNE",
    "KE SACH COMMUNE",
    "LAI HOA COMMUNE",
    "LIEU TU COMMUNE",
    "LONG HUNG COMMUNE",
    "LONG PHU COMMUNE",
    "LAM TAN COMMUNE",
    "LUONG TAM COMMUNE",
    "LICH HOI THUONG COMMUNE",
    "MY HUONG COMMUNE",
    "MY PHUOC COMMUNE",
    "MY TU COMMUNE",
    "NGOC TO COMMUNE",
    "NHU GIA COMMUNE",
    "NHON MY COMMUNE",
    "NHON AI COMMUNE",
    "PHONG NAM COMMUNE",
    "PHONG DIEN COMMUNE",
    "PHU LOC COMMUNE",
    "PHU TAM COMMUNE",
    "PHUONG BINH COMMUNE",
    "PHUNG HIEP COMMUNE",
    "THUAN HOA COMMUNE",
    "THANH AN COMMUNE",
    "THANH HOA COMMUNE",
    "THANH PHU COMMUNE",
    "THANH QUOI COMMUNE",
    "THANH THOI AN COMMUNE",
    "THANH XUAN COMMUNE",
    "THOI AN HOI COMMUNE",
    "THOI HUNG COMMUNE",
    "THOI LAI COMMUNE",
    "TRUNG HUNG COMMUNE",
    "TRUONG KHANH COMMUNE",
    "TRUONG LONG COMMUNE",
    "TRUONG LONG TAY COMMUNE",
    "TRUONG THANH COMMUNE",
    "TRUONG XUAN COMMUNE",
    "TRAN DE COMMUNE",
    "TAI VAN COMMUNE",
    "TAN BINH COMMUNE",
    "TAN HOA COMMUNE",
    "TAN LONG COMMUNE",
    "TAN PHUOC HUNG COMMUNE",
    "TAN THANH COMMUNE",
    "VINH HAI COMMUNE",
    "VINH LOI COMMUNE",
    "VINH THUAN DONG COMMUNE",
    "VINH THANH COMMUNE",
    "VINH TRINH COMMUNE",
    "VINH TUONG COMMUNE",
    "VINH VIEN COMMUNE",
    "VI THANH 1 COMMUNE",
    "VI THUY COMMUNE",
    "XA PHIEN COMMUNE",
    "DONG HIEP COMMUNE",
    "DONG PHUOC COMMUNE",
    "DONG THUAN COMMUNE",
    "DAI NGAI COMMUNE"
  ],
  "HUE City": [
    "AN CUU WARD",
    "DUONG NO WARD",
    "HOA CHAU WARD",
    "HUONG AN WARD",
    "HUONG THUY WARD",
    "HUONG TRA WARD",
    "KIM LONG WARD",
    "KIM TRA WARD",
    "MY THUONG WARD",
    "PHONG DINH WARD",
    "PHONG PHU WARD",
    "PHONG QUANG WARD",
    "PHONG THAI WARD",
    "PHONG DIEN WARD",
    "PHU BAI WARD",
    "PHU XUAN WARD",
    "THANH THUY WARD",
    "THUAN AN WARD",
    "THUAN HOA WARD",
    "THUY XUAN WARD",
    "VY DA WARD",
    "A LUOI 1 COMMUNE",
    "A LUOI 2 COMMUNE",
    "A LUOI 3 COMMUNE",
    "A LUOI 4 COMMUNE",
    "A LUOI 5 COMMUNE",
    "BINH DIEN COMMUNE",
    "CHAN MAY  LANG CO COMMUNE",
    "HUNG LOC COMMUNE",
    "KHE TRE COMMUNE",
    "LONG QUANG COMMUNE",
    "LOC AN COMMUNE",
    "NAM DONG COMMUNE",
    "PHU HO COMMUNE",
    "PHU LOC COMMUNE",
    "PHU VANG COMMUNE",
    "PHU VINH COMMUNE",
    "QUANG DIEN COMMUNE",
    "VINH LOC COMMUNE",
    "DAN DIEN COMMUNE"
  ],
  "HA NOI City": [
    "BA DINH WARD",
    "BACH MAI WARD",
    "BO DE WARD",
    "CHUONG MY WARD",
    "CAU GIAY WARD",
    "CUA NAM WARD",
    "DUONG NOI WARD",
    "GIANG VO WARD",
    "HAI BA TRUNG WARD",
    "HOAN KIEM WARD",
    "HOANG LIET WARD",
    "HOANG MAI WARD",
    "HA DONG WARD",
    "HONG HA WARD",
    "KHUONG DINH WARD",
    "KIM LIEN WARD",
    "KIEN HUNG WARD",
    "LONG BIEN WARD",
    "LANG WARD",
    "LINH NAM WARD",
    "NGHIA DO WARD",
    "NGOC HA WARD",
    "PHU DIEN WARD",
    "PHU LUONG WARD",
    "PHU THUONG WARD",
    "PHUC LOI WARD",
    "PHUONG LIET WARD",
    "SON TAY WARD",
    "THANH LIET WARD",
    "THANH XUAN WARD",
    "THUONG CAT WARD",
    "TAY HO WARD",
    "TAY MO WARD",
    "TAY TUU WARD",
    "TUNG THIEN WARD",
    "TUONG MAI WARD",
    "TU LIEM WARD",
    "VIET HUNG WARD",
    "VAN MIEU - QUOC TU GIAM WARD",
    "VINH HUNG WARD",
    "VINH TUY WARD",
    "XUAN PHUONG WARD",
    "XUAN DINH WARD",
    "YEN HOA WARD",
    "YEN NGHIA WARD",
    "YEN SO WARD",
    "O CHO DUA WARD",
    "DONG NGAC WARD",
    "DAI MO WARD",
    "DINH CONG WARD",
    "DONG DA WARD",
    "AN KHANH COMMUNE",
    "BA VI COMMUNE",
    "BAT TRANG COMMUNE",
    "BINH MINH COMMUNE",
    "BAT BAT COMMUNE",
    "CHUYEN MY COMMUNE",
    "CHUONG DUONG COMMUNE",
    "CO DO COMMUNE",
    "DAN HOA COMMUNE",
    "DUONG HOA COMMUNE",
    "GIA LAM COMMUNE",
    "HOAI DUC COMMUNE",
    "HAT MON COMMUNE",
    "HOA LAC COMMUNE",
    "HOA PHU COMMUNE",
    "HOA XA COMMUNE",
    "HUNG DAO COMMUNE",
    "HUONG SON COMMUNE",
    "HA BANG COMMUNE",
    "HONG SON COMMUNE",
    "HONG VAN COMMUNE",
    "KIM ANH COMMUNE",
    "KIEU PHU COMMUNE",
    "LIEN MINH COMMUNE",
    "MINH CHAU COMMUNE",
    "ME LINH COMMUNE",
    "MY DUC COMMUNE",
    "NAM PHU COMMUNE",
    "NGOC HOI COMMUNE",
    "NOI BAI COMMUNE",
    "PHU DONG COMMUNE",
    "PHU CAT COMMUNE",
    "PHU NGHIA COMMUNE",
    "PHU XUYEN COMMUNE",
    "PHUC LOC COMMUNE",
    "PHUC SON COMMUNE",
    "PHUC THINH COMMUNE",
    "PHUC THO COMMUNE",
    "PHUONG DUC COMMUNE",
    "QUANG MINH COMMUNE",
    "QUANG BI COMMUNE",
    "QUANG OAI COMMUNE",
    "QUOC OAI COMMUNE",
    "SUOI HAI COMMUNE",
    "SOC SON COMMUNE",
    "SON DONG COMMUNE",
    "TAM HUNG COMMUNE",
    "THANH OAI COMMUNE",
    "THANH TRI COMMUNE",
    "THIEN LOC COMMUNE",
    "THUAN AN COMMUNE",
    "THU LAM COMMUNE",
    "THUONG TIN COMMUNE",
    "THUONG PHUC COMMUNE",
    "THACH THAT COMMUNE",
    "TIEN THANG COMMUNE",
    "TRUNG GIA COMMUNE",
    "TRAN PHU COMMUNE",
    "TAY PHUONG COMMUNE",
    "VAN DINH COMMUNE",
    "VINH THANH COMMUNE",
    "VAT LAI COMMUNE",
    "XUAN MAI COMMUNE",
    "YEN BAI COMMUNE",
    "YEN LANG COMMUNE",
    "YEN XUAN COMMUNE",
    "O DIEN COMMUNE",
    "DA PHUC COMMUNE",
    "DAN PHUONG COMMUNE",
    "DOAI PHUONG COMMUNE",
    "DONG ANH COMMUNE",
    "DAI THANH COMMUNE",
    "DAI XUYEN COMMUNE",
    "UNG HOA COMMUNE",
    "UNG THIEN COMMUNE"
  ],
  "HAI PHONG City": [
    "AN BIEN WARD",
    "AN DUONG WARD",
    "AN HAI WARD",
    "AN PHONG WARD",
    "BACH DANG WARD",
    "BAC AN PHU WARD",
    "CHU VAN AN WARD",
    "CHI LINH WARD",
    "DUONG KINH WARD",
    "GIA VIEN WARD",
    "HOA BINH WARD",
    "HUNG DAO WARD",
    "HAI AN WARD",
    "HAI DUONG WARD",
    "HONG AN WARD",
    "HONG BANG WARD",
    "KINH MON WARD",
    "KIEN AN WARD",
    "LE CHAN WARD",
    "LE THANH NGHI WARD",
    "LE ICH MOC WARD",
    "LE DAI HANH WARD",
    "LUU KIEM WARD",
    "NAM TRIEU WARD",
    "NAM DO SON WARD",
    "NAM DONG WARD",
    "NGUYEN TRAI WARD",
    "NGUYEN DAI NANG WARD",
    "NGO QUYEN WARD",
    "NHI CHIEU WARD",
    "PHU LIEN WARD",
    "PHAM SU MANH WARD",
    "THIEN HUONG WARD",
    "THUY NGUYEN WARD",
    "THANH DONG WARD",
    "THACH KHOI WARD",
    "TRAN HUNG DAO WARD",
    "TRAN LIEU WARD",
    "TRAN NHAN TONG WARD",
    "TAN HUNG WARD",
    "TU MINH WARD",
    "VIET HOA WARD",
    "AI QUOC WARD",
    "DONG HAI WARD",
    "DO SON WARD",
    "AN HUNG COMMUNE",
    "AN KHANH COMMUNE",
    "AN LAO COMMUNE",
    "AN PHU COMMUNE",
    "AN QUANG COMMUNE",
    "AN THANH COMMUNE",
    "AN TRUONG COMMUNE",
    "BINH GIANG COMMUNE",
    "BAC THANH MIEN COMMUNE",
    "CHI MINH COMMUNE",
    "CHAN HUNG COMMUNE",
    "CAM GIANG COMMUNE",
    "GIA LOC COMMUNE",
    "GIA PHUC COMMUNE",
    "HA BAC COMMUNE",
    "HA NAM COMMUNE",
    "HA TAY COMMUNE",
    "HA DONG COMMUNE",
    "HUNG THANG COMMUNE",
    "HAI HUNG COMMUNE",
    "HONG CHAU COMMUNE",
    "HOP TIEN COMMUNE",
    "KHUC THUA DU COMMUNE",
    "KIM THANH COMMUNE",
    "KIEN HUNG COMMUNE",
    "KIEN HAI COMMUNE",
    "KIEN MINH COMMUNE",
    "KIEN THUY COMMUNE",
    "KE SAT COMMUNE",
    "LAI KHE COMMUNE",
    "LAC PHUONG COMMUNE",
    "MAO DIEN COMMUNE",
    "NAM AN PHU COMMUNE",
    "NAM SACH COMMUNE",
    "NAM THANH MIEN COMMUNE",
    "NGHI DUONG COMMUNE",
    "NGUYEN GIAP COMMUNE",
    "NGUYEN BINH KHIEM COMMUNE",
    "NGUYEN LUONG BANG COMMUNE",
    "NINH GIANG COMMUNE",
    "PHU THAI COMMUNE",
    "QUYET THANG COMMUNE",
    "THANH HA COMMUNE",
    "THANH MIEN COMMUNE",
    "THAI TAN COMMUNE",
    "THUONG HONG COMMUNE",
    "TIEN LANG COMMUNE",
    "TIEN MINH COMMUNE",
    "TRUONG TAN COMMUNE",
    "TRAN PHU COMMUNE",
    "TUE TINH COMMUNE",
    "TAN AN COMMUNE",
    "TAN KY COMMUNE",
    "TAN MINH COMMUNE",
    "TU KY COMMUNE",
    "VIET KHE COMMUNE",
    "VINH AM COMMUNE",
    "VINH BAO COMMUNE",
    "VINH HOA COMMUNE",
    "VINH HAI COMMUNE",
    "VINH LAI COMMUNE",
    "VINH THUAN COMMUNE",
    "VINH THINH COMMUNE",
    "YET KIEU COMMUNE",
    "DUONG AN COMMUNE",
    "DAI SON COMMUNE",
    "DAC KHU BACH LONG VI",
    "DAC KHU CAT HAI"
  ],
  "HO CHI MINH City": [
    "PHUONG  AN NHON",
    "PHUONG AN HOI TAY",
    "PHUONG AN HOI DONG",
    "PHUONG AN LAC",
    "PHUONG BAY HIEN",
    "PHUONG BINH HUNG HOA",
    "PHUONG BINH TRI DONG",
    "PHUONG BINH TAN",
    "PHUONG GO VAP",
    "PHUONG HANH THONG",
    "PHUONG KHANH HOI",
    "PHUONG THONG TAY HOI",
    "PHUONG TAN BINH",
    "PHUONG TAN HOA",
    "PHUONG TAN SON",
    "PHUONG TAN SON HOA",
    "PHUONG TAN SON NHAT",
    "PHUONG TAN TAO",
    "PHUONG VINH HOI",
    "PHUONG XOM CHIEU",
    "RACH DUA WARD",
    "AN KHANH WARD",
    "AN PHU WARD",
    "AN PHU DONG WARD",
    "AN DONG WARD",
    "BA RIA WARD",
    "BAN CO WARD",
    "BINH CO WARD",
    "BINH DUONG WARD",
    "BINH HOA WARD",
    "BINH LOI TRUNG WARD",
    "BINH PHU WARD",
    "BINH QUOI WARD",
    "BINH THANH WARD",
    "BINH THOI WARD",
    "BINH TIEN WARD",
    "BINH TRUNG WARD",
    "BINH TAY WARD",
    "BINH DONG WARD",
    "BEN CAT WARD",
    "BEN THANH WARD",
    "CHANH HIEP WARD",
    "CHANH HUNG WARD",
    "CHANH PHU HOA WARD",
    "CHO LON WARD",
    "CHO QUAN WARD",
    "CAT LAI WARD",
    "CAU KIEU WARD",
    "CAU ONG LANH WARD",
    "DIEN HONG WARD",
    "DI AN WARD",
    "GIA DINH WARD",
    "HIEP BINH WARD",
    "HOA BINH WARD",
    "HOA HUNG WARD",
    "HOA LOI WARD",
    "LINH XUAN WARD",
    "LONG BINH WARD",
    "LONG HUONG WARD",
    "LONG NGUYEN WARD",
    "LONG PHUOC WARD",
    "LONG TRUONG WARD",
    "LAI THIEU WARD",
    "MINH PHUNG WARD",
    "NHIEU LOC WARD",
    "PHU AN WARD",
    "PHU LAM WARD",
    "PHU LOI WARD",
    "PHU MY WARD",
    "PHU NHUAN WARD",
    "PHU THUAN WARD",
    "PHU THANH WARD",
    "PHU THO WARD",
    "PHU THO HOA WARD",
    "PHU DINH WARD",
    "PHUOC LONG WARD",
    "PHUOC THANG WARD",
    "SAI GON WARD",
    "TAM BINH WARD",
    "TAM LONG WARD",
    "TAM THANG WARD",
    "THUAN AN WARD",
    "THUAN GIAO WARD",
    "THANH MY TAY WARD",
    "THOI AN WARD",
    "THOI HOA WARD",
    "THU DAU MOT WARD",
    "THU DUC WARD",
    "TRUNG MY TAY WARD",
    "TAN HIEP WARD",
    "TAN HUNG WARD",
    "TAN HAI WARD",
    "TAN KHANH WARD",
    "TAN MY WARD",
    "TAN PHU WARD",
    "TAN PHUOC WARD",
    "TAN SON NHI WARD",
    "TAN THUAN WARD",
    "TAN THANH WARD",
    "TAN THOI HIEP WARD",
    "TAN UYEN WARD",
    "TAN DONG HIEP WARD",
    "TAN DINH WARD",
    "TAY NAM WARD",
    "TAY THANH WARD",
    "TANG NHON PHU WARD",
    "VINH TAN WARD",
    "VUNG TAU WARD",
    "VUON LAI WARD",
    "XUAN HOA WARD",
    "DONG HOA WARD",
    "DONG HUNG THUAN WARD",
    "DUC NHUAN WARD",
    "AN LONG COMMUNE",
    "AN NHON TAY COMMUNE",
    "AN THOI DONG COMMUNE",
    "BA DIEM COMMUNE",
    "BAU BANG COMMUNE",
    "BAU LAM COMMUNE",
    "BINH CHANH COMMUNE",
    "BINH CHAU COMMUNE",
    "BINH GIA COMMUNE",
    "BINH HUNG COMMUNE",
    "BINH KHANH COMMUNE",
    "BINH LOI COMMUNE",
    "BINH MY COMMUNE",
    "BAC TAN UYEN COMMUNE",
    "CHAU PHA COMMUNE",
    "CHAU DUC COMMUNE",
    "CAN GIO COMMUNE",
    "CU CHI COMMUNE",
    "DAU TIENG COMMUNE",
    "HIEP PHUOC COMMUNE",
    "HOA HIEP COMMUNE",
    "HOA HOI COMMUNE",
    "HOC MON COMMUNE",
    "HUNG LONG COMMUNE",
    "HO TRAM COMMUNE",
    "KIM LONG COMMUNE",
    "LONG HOA COMMUNE",
    "LONG HAI COMMUNE",
    "LONG SON COMMUNE",
    "LONG DIEN COMMUNE",
    "MINH THANH COMMUNE",
    "NGHIA THANH COMMUNE",
    "NGAI GIAO COMMUNE",
    "NHUAN DUC COMMUNE",
    "NHA BE COMMUNE",
    "PHU GIAO COMMUNE",
    "PHU HOA DONG COMMUNE",
    "PHUOC HOA COMMUNE",
    "PHUOC HAI COMMUNE",
    "PHUOC THANH COMMUNE",
    "THANH AN COMMUNE",
    "THAI MY COMMUNE",
    "THUONG TAN COMMUNE",
    "TRU VAN THO COMMUNE",
    "TAN AN HOI COMMUNE",
    "TAN NHUT COMMUNE",
    "TAN VINH LOC COMMUNE",
    "VINH LOC COMMUNE",
    "XUYEN MOC COMMUNE",
    "XUAN SON COMMUNE",
    "XUAN THOI SON COMMUNE",
    "DONG THANH COMMUNE",
    "DAT DO COMMUNE",
    "DAC KHU CON DAO"
  ],
  "DA NANG City": [
    "AN HAI WARD",
    "AN KHE WARD",
    "AN THANG WARD",
    "BAN THACH WARD",
    "CAM LE WARD",
    "HOA CUONG WARD",
    "HOA KHANH WARD",
    "HOA XUAN WARD",
    "HUONG TRA WARD",
    "HAI CHAU WARD",
    "HAI VAN WARD",
    "HOI AN WARD",
    "HOI AN TAY WARD",
    "HOI AN DONG WARD",
    "LIEN CHIEU WARD",
    "NGU HANH SON WARD",
    "QUANG PHU WARD",
    "SON TRA WARD",
    "TAM KY WARD",
    "THANH KHE WARD",
    "DIEN BAN WARD",
    "DIEN BAN BAC WARD",
    "DIEN BAN DONG WARD",
    "AVUONG COMMUNE",
    "BA NA COMMUNE",
    "BEN GIANG COMMUNE",
    "BEN HIEN COMMUNE",
    "CHIEN DAN COMMUNE",
    "DUY NGHIA COMMUNE",
    "DUY XUYEN COMMUNE",
    "GO NOI COMMUNE",
    "HIEP DUC COMMUNE",
    "HA NHA COMMUNE",
    "HOA TIEN COMMUNE",
    "HOA VANG COMMUNE",
    "HUNG SON COMMUNE",
    "KHAM DUC COMMUNE",
    "LA DEE COMMUNE",
    "LA EE COMMUNE",
    "LANH NGOC COMMUNE",
    "NAM GIANG COMMUNE",
    "NAM PHUOC COMMUNE",
    "NAM TRA MY COMMUNE",
    "NONG SON COMMUNE",
    "NUI THANH COMMUNE",
    "PHU NINH COMMUNE",
    "PHU THUAN COMMUNE",
    "PHUOC CHANH COMMUNE",
    "PHUOC HIEP COMMUNE",
    "PHUOC NANG COMMUNE",
    "PHUOC THANH COMMUNE",
    "PHUOC TRA COMMUNE",
    "QUE PHUOC COMMUNE",
    "QUE SON COMMUNE",
    "QUE SON TRUNG COMMUNE",
    "SONG KON COMMUNE",
    "SONG VANG COMMUNE",
    "SON CAM HA COMMUNE",
    "TAM ANH COMMUNE",
    "TAM HAI COMMUNE",
    "TAM MY COMMUNE",
    "TAM XUAN COMMUNE",
    "THU BON COMMUNE",
    "THANG AN COMMUNE",
    "THANG BINH COMMUNE",
    "THANG PHU COMMUNE",
    "THANG TRUONG COMMUNE",
    "THANG DIEN COMMUNE",
    "THUONG DUC COMMUNE",
    "THANH BINH COMMUNE",
    "THANH MY COMMUNE",
    "TIEN PHUOC COMMUNE",
    "TRA GIAP COMMUNE",
    "TRA LENG COMMUNE",
    "TRA LINH COMMUNE",
    "TRA LIEN COMMUNE",
    "TRA MY COMMUNE",
    "TRA TAN COMMUNE",
    "TRA TAP COMMUNE",
    "TRA VAN COMMUNE",
    "TRA DOC COMMUNE",
    "TAN HIEP COMMUNE",
    "TAY GIANG COMMUNE",
    "TAY HO COMMUNE",
    "VIET AN COMMUNE",
    "VU GIA COMMUNE",
    "XUAN PHU COMMUNE",
    "DIEN BAN TAY COMMUNE",
    "DONG GIANG COMMUNE",
    "DAI LOC COMMUNE",
    "DAC PRING COMMUNE",
    "DONG DUONG COMMUNE",
    "DUC PHU COMMUNE",
    "DAC KHU HOANG SA"
  ],
  "THANH HOA": [
    "BIM SON WARD",
    "HAM RONG WARD",
    "HAC THANH WARD",
    "HAI BINH WARD",
    "HAI LINH WARD",
    "NAM SAM SON WARD",
    "NGHI SON WARD",
    "NGUYET VIEN WARD",
    "NGOC SON WARD",
    "QUANG TRUNG WARD",
    "QUANG PHU WARD",
    "SAM SON WARD",
    "TRUC LAM WARD",
    "TAN DAN WARD",
    "TINH GIA WARD",
    "DAO DUY TU WARD",
    "DONG QUANG WARD",
    "DONG SON WARD",
    "DONG TIEN WARD",
    "AN NONG COMMUNE",
    "BA DINH COMMUNE",
    "BIEN THUONG COMMUNE",
    "BA THUOC COMMUNE",
    "BAT MOT COMMUNE",
    "CAC SON COMMUNE",
    "CONG CHINH COMMUNE",
    "CAM THACH COMMUNE",
    "CAM THUY COMMUNE",
    "CAM TAN COMMUNE",
    "CAM TU COMMUNE",
    "CAM VAN COMMUNE",
    "CO LUNG COMMUNE",
    "GIAO AN COMMUNE",
    "HIEN KIET COMMUNE",
    "HOA LOC COMMUNE",
    "HOAT GIANG COMMUNE",
    "HOANG CHAU COMMUNE",
    "HOANG GIANG COMMUNE",
    "HOANG HOA COMMUNE",
    "HOANG LOC COMMUNE",
    "HOANG PHU COMMUNE",
    "HOANG SON COMMUNE",
    "HOANG THANH COMMUNE",
    "HOANG TIEN COMMUNE",
    "HA LONG COMMUNE",
    "HA TRUNG COMMUNE",
    "HOA QUY COMMUNE",
    "HAU LOC COMMUNE",
    "HO VUONG COMMUNE",
    "HOI XUAN COMMUNE",
    "HOP TIEN COMMUNE",
    "KIM TAN COMMUNE",
    "KIEN THO COMMUNE",
    "LAM SON COMMUNE",
    "LINH SON COMMUNE",
    "LUAN THANH COMMUNE",
    "LINH TOAI COMMUNE",
    "LUU VE COMMUNE",
    "LUONG SON COMMUNE",
    "MINH SON COMMUNE",
    "MUONG CHANH COMMUNE",
    "MUONG LAT COMMUNE",
    "MUONG LY COMMUNE",
    "MUONG MIN COMMUNE",
    "MAU LAM COMMUNE",
    "NA MEO COMMUNE",
    "NAM XUAN COMMUNE",
    "NGA AN COMMUNE",
    "NGA SON COMMUNE",
    "NGA THANG COMMUNE",
    "NGUYET AN COMMUNE",
    "NGOC LIEN COMMUNE",
    "NGOC LAC COMMUNE",
    "NGOC TRAO COMMUNE",
    "NHI SON COMMUNE",
    "NHU THANH COMMUNE",
    "NHU XUAN COMMUNE",
    "NONG CONG COMMUNE",
    "PHU LE COMMUNE",
    "PHU XUAN COMMUNE",
    "PU LUONG COMMUNE",
    "PU NHI COMMUNE",
    "QUAN SON COMMUNE",
    "QUANG CHIEU COMMUNE",
    "QUY LUONG COMMUNE",
    "QUY LOC COMMUNE",
    "QUANG BINH COMMUNE",
    "QUANG CHINH COMMUNE",
    "QUANG NGOC COMMUNE",
    "QUANG NINH COMMUNE",
    "QUANG YEN COMMUNE",
    "SAO VANG COMMUNE",
    "SON THUY COMMUNE",
    "SON DIEN COMMUNE",
    "TAM CHUNG COMMUNE",
    "TAM LU COMMUNE",
    "TAM THANH COMMUNE",
    "THANH KY COMMUNE",
    "THANH PHONG COMMUNE",
    "THANH QUAN COMMUNE",
    "THIEN PHU COMMUNE",
    "THIET ONG COMMUNE",
    "THIEU HOA COMMUNE",
    "THIEU QUANG COMMUNE",
    "THIEU TIEN COMMUNE",
    "THIEU TOAN COMMUNE",
    "THIEU TRUNG COMMUNE",
    "THANH VINH COMMUNE",
    "THANG BINH COMMUNE",
    "THUONG XUAN COMMUNE",
    "THUONG NINH COMMUNE",
    "THACH BINH COMMUNE",
    "THACH LAP COMMUNE",
    "THACH QUANG COMMUNE",
    "THANG LOC COMMUNE",
    "THANG LOI COMMUNE",
    "THO BINH COMMUNE",
    "THO LONG COMMUNE",
    "THO LAP COMMUNE",
    "THO NGOC COMMUNE",
    "THO PHU COMMUNE",
    "THO XUAN COMMUNE",
    "TIEN TRANG COMMUNE",
    "TRIEU LOC COMMUNE",
    "TRIEU SON COMMUNE",
    "TRUNG CHINH COMMUNE",
    "TRUNG HA COMMUNE",
    "TRUNG LY COMMUNE",
    "TRUNG SON COMMUNE",
    "TRUNG THANH COMMUNE",
    "TRUONG LAM COMMUNE",
    "TRUONG VAN COMMUNE",
    "TAN NINH COMMUNE",
    "TAN THANH COMMUNE",
    "TAN TIEN COMMUNE",
    "TAY DO COMMUNE",
    "TUONG LINH COMMUNE",
    "TONG SON COMMUNE",
    "VAN DU COMMUNE",
    "VAN NHO COMMUNE",
    "VAN PHU COMMUNE",
    "VINH LOC COMMUNE",
    "VAN LOC COMMUNE",
    "VAN XUAN COMMUNE",
    "XUAN BINH COMMUNE",
    "XUAN CHINH COMMUNE",
    "XUAN DU COMMUNE",
    "XUAN HOA COMMUNE",
    "XUAN LAP COMMUNE",
    "XUAN THAI COMMUNE",
    "XUAN TIN COMMUNE",
    "YEN KHUONG COMMUNE",
    "YEN NHAN COMMUNE",
    "YEN NINH COMMUNE",
    "YEN PHU COMMUNE",
    "YEN THANG COMMUNE",
    "YEN THO COMMUNE",
    "YEN TRUONG COMMUNE",
    "YEN DINH COMMUNE",
    "DIEN LU COMMUNE",
    "DIEN QUANG COMMUNE",
    "DONG THANH COMMUNE",
    "DINH HOA COMMUNE",
    "DINH TAN COMMUNE",
    "DONG LUONG COMMUNE",
    "DONG TIEN COMMUNE"
  ],
  "THAI NGUYEN": [
    "BA XUYEN WARD",
    "BACH QUANG WARD",
    "BAC KAN WARD",
    "GIA SANG WARD",
    "LINH SON WARD",
    "PHAN DINH PHUNG WARD",
    "PHUC THUAN WARD",
    "PHO YEN WARD",
    "QUAN TRIEU WARD",
    "QUYET THANG WARD",
    "SONG CONG WARD",
    "TRUNG THANH WARD",
    "TICH LUONG WARD",
    "VAN XUAN WARD",
    "DUC XUAN WARD",
    "AN KHANH COMMUNE",
    "BA BE COMMUNE",
    "BINH THANH COMMUNE",
    "BINH YEN COMMUNE",
    "BACH THONG COMMUNE",
    "BANG THANH COMMUNE",
    "BANG VAN COMMUNE",
    "CAO MINH COMMUNE",
    "CHO MOI COMMUNE",
    "CHO RA COMMUNE",
    "CHO DON COMMUNE",
    "CON MINH COMMUNE",
    "CUONG LOI COMMUNE",
    "CAM GIANG COMMUNE",
    "DAN TIEN COMMUNE",
    "HIEP LUC COMMUNE",
    "HOP THANH COMMUNE",
    "KHA SON COMMUNE",
    "KIM PHUONG COMMUNE",
    "LA BANG COMMUNE",
    "LA HIEN COMMUNE",
    "LAM VY COMMUNE",
    "NA RI COMMUNE",
    "NAM CUONG COMMUNE",
    "NAM HOA COMMUNE",
    "NGHINH TUONG COMMUNE",
    "NGHIEN LOAN COMMUNE",
    "NGHIA TA COMMUNE",
    "NGAN SON COMMUNE",
    "NA PHAC COMMUNE",
    "PHONG QUANG COMMUNE",
    "PHU BINH COMMUNE",
    "PHU LUONG COMMUNE",
    "PHU LAC COMMUNE",
    "PHU THINH COMMUNE",
    "PHU XUYEN COMMUNE",
    "PHU DINH COMMUNE",
    "PHUC LOC COMMUNE",
    "PHUONG TIEN COMMUNE",
    "PHU THONG COMMUNE",
    "QUANG SON COMMUNE",
    "QUAN CHU COMMUNE",
    "QUANG BACH COMMUNE",
    "SANG MOC COMMUNE",
    "THANH MAI COMMUNE",
    "THANH THINH COMMUNE",
    "THANH CONG COMMUNE",
    "THUONG MINH COMMUNE",
    "THUONG QUAN COMMUNE",
    "THAN SA COMMUNE",
    "TRUNG HOI COMMUNE",
    "TRANG XA COMMUNE",
    "TRAI CAU COMMUNE",
    "TRAN PHU COMMUNE",
    "TAN CUONG COMMUNE",
    "TAN KHANH COMMUNE",
    "TAN KY COMMUNE",
    "TAN THANH COMMUNE",
    "VO TRANH COMMUNE",
    "VO NHAI COMMUNE",
    "VAN HAN COMMUNE",
    "VAN LANG COMMUNE",
    "VINH THONG COMMUNE",
    "VAN PHU COMMUNE",
    "XUAN DUONG COMMUNE",
    "YEN BINH COMMUNE",
    "YEN PHONG COMMUNE",
    "YEN THINH COMMUNE",
    "YEN TRACH COMMUNE",
    "DIEM THUY COMMUNE",
    "DAI PHUC COMMUNE",
    "DAI TU COMMUNE",
    "DINH HOA COMMUNE",
    "DONG HY COMMUNE",
    "DONG PHUC COMMUNE",
    "DUC LUONG COMMUNE"
  ],
  "TUYEN QUANG": [
    "AN TUONG WARD",
    "BINH THUAN WARD",
    "HA GIANG 1 WARD",
    "HA GIANG 2 WARD",
    "MINH XUAN WARD",
    "MY LAM WARD",
    "NONG TIEN WARD",
    "BINH AN COMMUNE",
    "BINH CA COMMUNE",
    "BINH XA COMMUNE",
    "BACH NGOC COMMUNE",
    "BACH XA COMMUNE",
    "BACH DICH COMMUNE",
    "BAN MAY COMMUNE",
    "BAC ME COMMUNE",
    "BAC QUANG COMMUNE",
    "BANG HANH COMMUNE",
    "BANG LANG COMMUNE",
    "CAO BO COMMUNE",
    "CHIEM HOA COMMUNE",
    "CAN TY COMMUNE",
    "CON LON COMMUNE",
    "DU GIA COMMUNE",
    "GIAP TRUNG COMMUNE",
    "HOA AN COMMUNE",
    "HOANG SU PHI COMMUNE",
    "HAM YEN COMMUNE",
    "HUNG AN COMMUNE",
    "HUNG LOI COMMUNE",
    "HUNG DUC COMMUNE",
    "HO THAU COMMUNE",
    "HONG SON COMMUNE",
    "HONG THAI COMMUNE",
    "KHUON LUNG COMMUNE",
    "KHAU VAI COMMUNE",
    "KIM BINH COMMUNE",
    "KIEN DAI COMMUNE",
    "KIEN THIET COMMUNE",
    "LAO CHAI COMMUNE",
    "LINH HO COMMUNE",
    "LIEN HIEP COMMUNE",
    "LAM BINH COMMUNE",
    "LUNG TAM COMMUNE",
    "LUNG CU COMMUNE",
    "LUNG PHIN COMMUNE",
    "LUC HANH COMMUNE",
    "MINH NGOC COMMUNE",
    "MINH QUANG COMMUNE",
    "MINH SON COMMUNE",
    "MINH THANH COMMUNE",
    "MINH TAN COMMUNE",
    "MEO VAC COMMUNE",
    "MAU DUE COMMUNE",
    "NGHIA THUAN COMMUNE",
    "NGOC LONG COMMUNE",
    "NGOC DUONG COMMUNE",
    "NHU KHE COMMUNE",
    "NIEM SON COMMUNE",
    "NA HANG COMMUNE",
    "NAM DAN COMMUNE",
    "NAM DICH COMMUNE",
    "PHU LUU COMMUNE",
    "PHU LINH COMMUNE",
    "PHU LUONG COMMUNE",
    "PHO BANG COMMUNE",
    "PA VAY SU COMMUNE",
    "PO LY NGAI COMMUNE",
    "QUANG BINH COMMUNE",
    "QUAN BA COMMUNE",
    "QUANG NGUYEN COMMUNE",
    "SA PHIN COMMUNE",
    "SON DUONG COMMUNE",
    "SON THUY COMMUNE",
    "SON VI COMMUNE",
    "SUNG MANG COMMUNE",
    "THANH THUY COMMUNE",
    "THUAN HOA COMMUNE",
    "THANG TIN COMMUNE",
    "THAI BINH COMMUNE",
    "THAI HOA COMMUNE",
    "THAI SON COMMUNE",
    "THONG NGUYEN COMMUNE",
    "THUONG LAM COMMUNE",
    "THUONG NONG COMMUNE",
    "THUONG SON COMMUNE",
    "THANG MO COMMUNE",
    "TIEN NGUYEN COMMUNE",
    "TIEN YEN COMMUNE",
    "TRI PHU COMMUNE",
    "TRUNG HA COMMUNE",
    "TRUNG SON COMMUNE",
    "TRUNG THINH COMMUNE",
    "TRUONG SINH COMMUNE",
    "TAT NGA COMMUNE",
    "TAN AN COMMUNE",
    "TAN LONG COMMUNE",
    "TAN MY COMMUNE",
    "TAN QUANG COMMUNE",
    "TAN THANH COMMUNE",
    "TAN TIEN COMMUNE",
    "TAN TRAO COMMUNE",
    "TAN TRINH COMMUNE",
    "TUNG BA COMMUNE",
    "TUNG VAI COMMUNE",
    "VIET LAM COMMUNE",
    "VINH TUY COMMUNE",
    "VI XUYEN COMMUNE",
    "XUAN GIANG COMMUNE",
    "XUAN VAN COMMUNE",
    "XIN MAN COMMUNE",
    "YEN CUONG COMMUNE",
    "YEN HOA COMMUNE",
    "YEN LAP COMMUNE",
    "YEN MINH COMMUNE",
    "YEN NGUYEN COMMUNE",
    "YEN PHU COMMUNE",
    "YEN SON COMMUNE",
    "YEN THANH COMMUNE",
    "DONG THO COMMUNE",
    "DUONG HONG COMMUNE",
    "DUONG THUONG COMMUNE",
    "DONG TAM COMMUNE",
    "DONG VAN COMMUNE",
    "DONG YEN COMMUNE"
  ],
  "TAY NINH": [
    "AN TINH WARD",
    "BINH MINH WARD",
    "GIA LOC WARD",
    "GO DAU WARD",
    "HOA THANH WARD",
    "KHANH HAU WARD",
    "KIEN TUONG WARD",
    "LONG AN WARD",
    "LONG HOA WARD",
    "NINH THANH WARD",
    "THANH DIEN WARD",
    "TRANG BANG WARD",
    "TAN AN WARD",
    "TAN NINH WARD",
    "AN LUC LONG COMMUNE",
    "AN NINH COMMUNE",
    "BINH HIEP COMMUNE",
    "BINH HOA COMMUNE",
    "BINH THANH COMMUNE",
    "BINH DUC COMMUNE",
    "BEN CAU COMMUNE",
    "BEN LUC COMMUNE",
    "CHAU THANH COMMUNE",
    "CAN GIUOC COMMUNE",
    "CAN DUOC COMMUNE",
    "CAU KHOI COMMUNE",
    "DUONG MINH CHAU COMMUNE",
    "HIEP HOA COMMUNE",
    "HOA HOI COMMUNE",
    "HOA KHANH COMMUNE",
    "HUNG THUAN COMMUNE",
    "HUNG DIEN COMMUNE",
    "HAO DUOC COMMUNE",
    "HAU NGHIA COMMUNE",
    "HAU THANH COMMUNE",
    "KHANH HUNG COMMUNE",
    "LONG CANG COMMUNE",
    "LONG CHU COMMUNE",
    "LONG HUU COMMUNE",
    "LONG THUAN COMMUNE",
    "LUONG HOA COMMUNE",
    "LOC NINH COMMUNE",
    "MOC HOA COMMUNE",
    "MY AN COMMUNE",
    "MY HANH COMMUNE",
    "MY LE COMMUNE",
    "MY LOC COMMUNE",
    "MY QUY COMMUNE",
    "MY THANH COMMUNE",
    "MY YEN COMMUNE",
    "NHON HOA LAP COMMUNE",
    "NHON NINH COMMUNE",
    "NHUT TAO COMMUNE",
    "NINH DIEN COMMUNE",
    "PHUOC CHI COMMUNE",
    "PHUOC LY COMMUNE",
    "PHUOC THANH COMMUNE",
    "PHUOC VINH COMMUNE",
    "PHUOC VINH TAY COMMUNE",
    "RACH KIEN COMMUNE",
    "THUAN MY COMMUNE",
    "THANH BINH COMMUNE",
    "THANH HOA COMMUNE",
    "THANH LOI COMMUNE",
    "THANH PHUOC COMMUNE",
    "THANH DUC COMMUNE",
    "THU THUA COMMUNE",
    "TRUONG MIT COMMUNE",
    "TRA VONG COMMUNE",
    "TUYEN BINH COMMUNE",
    "TUYEN THANH COMMUNE",
    "TAN BIEN COMMUNE",
    "TAN CHAU COMMUNE",
    "TAN HOA COMMUNE",
    "TAN HUNG COMMUNE",
    "TAN HOI COMMUNE",
    "TAN LONG COMMUNE",
    "TAN LAN COMMUNE",
    "TAN LAP COMMUNE",
    "TAN PHU COMMUNE",
    "TAN THANH COMMUNE",
    "TAN TRU COMMUNE",
    "TAN TAY COMMUNE",
    "TAN TAP COMMUNE",
    "TAN DONG COMMUNE",
    "TAM VU COMMUNE",
    "VAM CO COMMUNE",
    "VINH CHAU COMMUNE",
    "VINH CONG COMMUNE",
    "VINH HUNG COMMUNE",
    "VINH THANH COMMUNE",
    "DONG THANH COMMUNE",
    "DUC HUE COMMUNE",
    "DUC HOA COMMUNE",
    "DUC LAP COMMUNE"
  ],
  "VINH LONG": [
    "PHUONG LONG CHAU",
    "PHUONG PHUOC HAU",
    "PHUONG THANH DUC",
    "AN HOI WARD",
    "BINH MINH WARD",
    "BEN TRE WARD",
    "CAI VON WARD",
    "DUYEN HAI WARD",
    "HOA THUAN WARD",
    "LONG DUC WARD",
    "NGUYET HOA WARD",
    "PHU KHUONG WARD",
    "PHU TAN WARD",
    "SON DONG WARD",
    "TRA VINH WARD",
    "TRUONG LONG HOA WARD",
    "TAN HANH WARD",
    "TAN NGAI WARD",
    "DONG THANH WARD",
    "XA AN BINH",
    "AN HIEP COMMUNE",
    "AN NGAI TRUNG COMMUNE",
    "AN PHU TAN COMMUNE",
    "AN QUI COMMUNE",
    "AN TRUONG COMMUNE",
    "AN DINH COMMUNE",
    "BA TRI COMMUNE",
    "BINH PHUOC COMMUNE",
    "BINH PHU COMMUNE",
    "BINH DAI COMMUNE",
    "BAO THANH COMMUNE",
    "CHAU HOA COMMUNE",
    "CHAU HUNG COMMUNE",
    "CHAU THANH COMMUNE",
    "CHO LACH COMMUNE",
    "CANG LONG COMMUNE",
    "CAI NGANG COMMUNE",
    "CAI NHUM COMMUNE",
    "CAU KE COMMUNE",
    "CAU NGANG COMMUNE",
    "GIAO LONG COMMUNE",
    "GIONG TROM COMMUNE",
    "HIEU PHUNG COMMUNE",
    "HIEU THANH COMMUNE",
    "HIEP MY COMMUNE",
    "HAM GIANG COMMUNE",
    "HOA BINH COMMUNE",
    "HOA HIEP COMMUNE",
    "HOA MINH COMMUNE",
    "HUNG HOA COMMUNE",
    "HUNG KHANH TRUNG COMMUNE",
    "HUNG MY COMMUNE",
    "HUNG NHUONG COMMUNE",
    "HUONG MY COMMUNE",
    "LONG HIEP COMMUNE",
    "LONG HOA COMMUNE",
    "LONG HO COMMUNE",
    "LONG HUU COMMUNE",
    "LONG THANH COMMUNE",
    "LONG VINH COMMUNE",
    "LUU NGHIEP ANH COMMUNE",
    "LUONG HOA COMMUNE",
    "LUONG PHU COMMUNE",
    "LOC THUAN COMMUNE",
    "LUC SY THANH COMMUNE",
    "MO CAY COMMUNE",
    "MY CHANH HOA COMMUNE",
    "MY LONG COMMUNE",
    "MY THUAN COMMUNE",
    "NGAI TU COMMUNE",
    "NGU LAC COMMUNE",
    "NHUAN PHU TAN COMMUNE",
    "NHON PHU COMMUNE",
    "NHI LONG COMMUNE",
    "NHI TRUONG COMMUNE",
    "PHONG THANH COMMUNE",
    "PHU PHUNG COMMUNE",
    "PHU QUOI COMMUNE",
    "PHU THUAN COMMUNE",
    "PHU TUC COMMUNE",
    "PHUOC LONG COMMUNE",
    "PHUOC MY TRUNG COMMUNE",
    "QUOI AN COMMUNE",
    "QUOI THIEN COMMUNE",
    "QUOI DIEN COMMUNE",
    "SONG LOC COMMUNE",
    "SONG PHU COMMUNE",
    "TAM BINH COMMUNE",
    "TAM NGAI COMMUNE",
    "THANH THOI COMMUNE",
    "THANH HAI COMMUNE",
    "THANH PHONG COMMUNE",
    "THANH PHU COMMUNE",
    "THANH PHUOC COMMUNE",
    "THANH TRI COMMUNE",
    "THOI THUAN COMMUNE",
    "TIEN THUY COMMUNE",
    "TIEU CAN COMMUNE",
    "TRUNG HIEP COMMUNE",
    "TRUNG NGAI COMMUNE",
    "TRUNG THANH COMMUNE",
    "TRA CON COMMUNE",
    "TRA CU COMMUNE",
    "TRA ON COMMUNE",
    "TAN AN COMMUNE",
    "TAN HAO COMMUNE",
    "TAN HOA COMMUNE",
    "TAN LONG HOI COMMUNE",
    "TAN LUOC COMMUNE",
    "TAN PHU COMMUNE",
    "TAN QUOI COMMUNE",
    "TAN THANH BINH COMMUNE",
    "TAN THUY COMMUNE",
    "TAN XUAN COMMUNE",
    "TAP NGAI COMMUNE",
    "TAP SON COMMUNE",
    "VINH KIM COMMUNE",
    "VINH XUAN COMMUNE",
    "VINH THANH COMMUNE",
    "DON CHAU COMMUNE",
    "DONG HAI COMMUNE",
    "DAI AN COMMUNE",
    "DAI DIEN COMMUNE",
    "DONG KHOI COMMUNE"
  ],
  "DIEN BIEN": [
    "MUONG LAY WARD",
    "MUONG THANH WARD",
    "DIEN BIEN PHU WARD",
    "XA NAM NEN",
    "BUNG LAO COMMUNE",
    "CHIENG SINH COMMUNE",
    "CHA TO COMMUNE",
    "MUONG CHA COMMUNE",
    "MUONG LUAN COMMUNE",
    "MUONG LAN COMMUNE",
    "MUONG MUN COMMUNE",
    "MUONG NHA COMMUNE",
    "MUONG NHE COMMUNE",
    "MUONG PHANG COMMUNE",
    "MUONG PON COMMUNE",
    "MUONG TOONG COMMUNE",
    "MUONG TUNG COMMUNE",
    "MUONG ANG COMMUNE",
    "NA SANG COMMUNE",
    "NA SON COMMUNE",
    "NA BUNG COMMUNE",
    "NA HY COMMUNE",
    "NA TAU COMMUNE",
    "NUA NGAM COMMUNE",
    "NAM KE COMMUNE",
    "PA HAM COMMUNE",
    "PHINH GIANG COMMUNE",
    "PU NHI COMMUNE",
    "PU NHUNG COMMUNE",
    "QUAI TO COMMUNE",
    "QUANG LAM COMMUNE",
    "SAM MUN COMMUNE",
    "SI PA PHIN COMMUNE",
    "SANG NHE COMMUNE",
    "SIN CHAI COMMUNE",
    "SIN THAU COMMUNE",
    "SINH PHINH COMMUNE",
    "THANH AN COMMUNE",
    "THANH NUA COMMUNE",
    "THANH YEN COMMUNE",
    "TUAN GIAO COMMUNE",
    "TIA DINH COMMUNE",
    "TUA CHUA COMMUNE",
    "TUA THANG COMMUNE",
    "XA DUNG COMMUNE"
  ],
  "DAK LAK": [
    "BUON MA THUOT WARD",
    "THANH NHAT WARD",
    "TAN AN WARD",
    "TAN LAP WARD",
    "BUON HO WARD",
    "BINH KIEN WARD",
    "CU BAO WARD",
    "EA KAO WARD",
    "HOA HIEP WARD",
    "PHU YEN WARD",
    "SONG CAU WARD",
    "TUY HOA WARD",
    "XUAN DAI WARD",
    "DONG HOA WARD",
    "BUON DON COMMUNE",
    "CUOR DANG COMMUNE",
    "CU MGAR COMMUNE",
    "CU MTA COMMUNE",
    "CU PRAO COMMUNE",
    "CU PUI COMMUNE",
    "CU PONG COMMUNE",
    "CU YANG COMMUNE",
    "DANG KANG COMMUNE",
    "DLIE YA COMMUNE",
    "DRAY BHANG COMMUNE",
    "DUR KMAL COMMUNE",
    "EA BUNG COMMUNE",
    "EA BA COMMUNE",
    "EA DRONG COMMUNE",
    "EA DRANG COMMUNE",
    "EA HIAO COMMUNE",
    "EA HLEO COMMUNE",
    "EA KAR COMMUNE",
    "EA KHAL COMMUNE",
    "EA KIET COMMUNE",
    "EA KLY COMMUNE",
    "EA KNUEC COMMUNE",
    "EA KNOP COMMUNE",
    "EA KTUR COMMUNE",
    "EA LY COMMUNE",
    "EA MDROH COMMUNE",
    "EA NA COMMUNE",
    "EA NING COMMUNE",
    "EA NUOL COMMUNE",
    "EA PHE COMMUNE",
    "EA PAL COMMUNE",
    "EA RIENG COMMUNE",
    "EA ROK COMMUNE",
    "EA SUP COMMUNE",
    "EA TRANG COMMUNE",
    "EA TUL COMMUNE",
    "EA WER COMMUNE",
    "EA WY COMMUNE",
    "EA O COMMUNE",
    "HOA MY COMMUNE",
    "HOA PHU COMMUNE",
    "HOA SON COMMUNE",
    "HOA THINH COMMUNE",
    "HOA XUAN COMMUNE",
    "IA LOP COMMUNE",
    "IA RVE COMMUNE",
    "KRONG ANA COMMUNE",
    "KRONG BONG COMMUNE",
    "KRONG BUK COMMUNE",
    "KRONG NO COMMUNE",
    "KRONG NANG COMMUNE",
    "KRONG PAC COMMUNE",
    "KRONG A COMMUNE",
    "LIEN SON LAK COMMUNE",
    "MDRAK COMMUNE",
    "NAM KA COMMUNE",
    "PHU HOA 1 COMMUNE",
    "PHU HOA 2 COMMUNE",
    "PHU MO COMMUNE",
    "PHU XUAN COMMUNE",
    "PONG DRANG COMMUNE",
    "QUANG PHU COMMUNE",
    "SUOI TRAI COMMUNE",
    "SONG HINH COMMUNE",
    "SON HOA COMMUNE",
    "SON THANH COMMUNE",
    "TAM GIANG COMMUNE",
    "TUY AN BAC COMMUNE",
    "TUY AN NAM COMMUNE",
    "TUY AN TAY COMMUNE",
    "TUY AN DONG COMMUNE",
    "TAN TIEN COMMUNE",
    "TAY HOA COMMUNE",
    "TAY SON COMMUNE",
    "VAN HOA COMMUNE",
    "VU BON COMMUNE",
    "XUAN CANH COMMUNE",
    "XUAN LANH COMMUNE",
    "XUAN LOC COMMUNE",
    "XUAN PHUOC COMMUNE",
    "XUAN THO COMMUNE",
    "YANG MAO COMMUNE",
    "O LOAN COMMUNE",
    "DAK LIENG COMMUNE",
    "DAK PHOI COMMUNE",
    "DONG XUAN COMMUNE",
    "DUC BINH COMMUNE"
  ],
  "DONG NAI": [
    "AN LOC WARD",
    "BIEN HOA WARD",
    "BINH LONG WARD",
    "BINH LOC WARD",
    "BINH PHUOC WARD",
    "BAO VINH WARD",
    "CHON THANH WARD",
    "HANG GON WARD",
    "HO NAI WARD",
    "LONG BINH WARD",
    "LONG HUNG WARD",
    "LONG KHANH WARD",
    "MINH HUNG WARD",
    "PHUOC BINH WARD",
    "PHUOC LONG WARD",
    "PHUOC TAN WARD",
    "TAM HIEP WARD",
    "TAM PHUOC WARD",
    "TRANG DAI WARD",
    "TRAN BIEN WARD",
    "TAN TRIEU WARD",
    "XUAN LAP WARD",
    "DONG XOAI WARD",
    "AN PHUOC COMMUNE",
    "AN VIEN COMMUNE",
    "BOM BO COMMUNE",
    "BAU HAM COMMUNE",
    "BINH AN COMMUNE",
    "BINH MINH COMMUNE",
    "BINH TAN COMMUNE",
    "BU GIA MAP COMMUNE",
    "BU DANG COMMUNE",
    "CAM MY COMMUNE",
    "DAU GIAY COMMUNE",
    "GIA KIEM COMMUNE",
    "HUNG PHUOC COMMUNE",
    "HUNG THINH COMMUNE",
    "LA NGA COMMUNE",
    "LONG HA COMMUNE",
    "LONG PHUOC COMMUNE",
    "LONG THANH COMMUNE",
    "LOC HUNG COMMUNE",
    "LOC NINH COMMUNE",
    "LOC QUANG COMMUNE",
    "LOC THANH COMMUNE",
    "LOC TAN COMMUNE",
    "MINH DUC COMMUNE",
    "NAM CAT TIEN COMMUNE",
    "NGHIA TRUNG COMMUNE",
    "NHA BICH COMMUNE",
    "NHON TRACH COMMUNE",
    "PHU HOA COMMUNE",
    "PHU LAM COMMUNE",
    "PHU LY COMMUNE",
    "PHU NGHIA COMMUNE",
    "PHU RIENG COMMUNE",
    "PHU TRUNG COMMUNE",
    "PHU VINH COMMUNE",
    "PHUOC AN COMMUNE",
    "PHUOC SON COMMUNE",
    "PHUOC THAI COMMUNE",
    "SONG RAY COMMUNE",
    "THANH SON COMMUNE",
    "THIEN HUNG COMMUNE",
    "THUAN LOI COMMUNE",
    "THO SON COMMUNE",
    "THONG NHAT COMMUNE",
    "TRANG BOM COMMUNE",
    "TRI AN COMMUNE",
    "TA LAI COMMUNE",
    "TAN AN COMMUNE",
    "TAN HUNG COMMUNE",
    "TAN KHAI COMMUNE",
    "TAN LOI COMMUNE",
    "TAN PHU COMMUNE",
    "TAN QUAN COMMUNE",
    "TAN TIEN COMMUNE",
    "XUAN BAC COMMUNE",
    "XUAN HOA COMMUNE",
    "XUAN LOC COMMUNE",
    "XUAN PHU COMMUNE",
    "XUAN QUE COMMUNE",
    "XUAN THANH COMMUNE",
    "XUAN DONG COMMUNE",
    "XUAN DUONG COMMUNE",
    "XUAN DINH COMMUNE",
    "DA KIA COMMUNE",
    "DAK LUA COMMUNE",
    "DAK NHAU COMMUNE",
    "DAK O COMMUNE",
    "DAI PHUOC COMMUNE",
    "DINH QUAN COMMUNE",
    "DONG PHU COMMUNE",
    "DONG TAM COMMUNE"
  ],
  "DONG THAP": [
    "AN BINH WARD",
    "BINH XUAN WARD",
    "CAI LAY WARD",
    "CAO LANH WARD",
    "GO CONG WARD",
    "HONG NGU WARD",
    "LONG THUAN WARD",
    "MY NGAI WARD",
    "MY PHONG WARD",
    "MY PHUOC TAY WARD",
    "MY THO WARD",
    "MY TRA WARD",
    "NHI QUY WARD",
    "SA DEC WARD",
    "SON QUI WARD",
    "THANH HOA WARD",
    "THUONG LAC WARD",
    "THOI SON WARD",
    "TRUNG AN WARD",
    "DAO THANH WARD",
    "AN HOA COMMUNE",
    "AN HUU COMMUNE",
    "AN LONG COMMUNE",
    "AN PHUOC COMMUNE",
    "AN THANH THUY COMMUNE",
    "BA SAO COMMUNE",
    "BINH HANG TRUNG COMMUNE",
    "BINH NINH COMMUNE",
    "BINH PHU COMMUNE",
    "BINH THANH COMMUNE",
    "BINH TRUNG COMMUNE",
    "CHAU THANH COMMUNE",
    "CHO GAO COMMUNE",
    "CAI BE COMMUNE",
    "GIA THUAN COMMUNE",
    "GO CONG DONG COMMUNE",
    "HIEP DUC COMMUNE",
    "HOA LONG COMMUNE",
    "HUNG THANH COMMUNE",
    "HAU MY COMMUNE",
    "HOI CU COMMUNE",
    "KIM SON COMMUNE",
    "LAI VUNG COMMUNE",
    "LONG BINH COMMUNE",
    "LONG HUNG COMMUNE",
    "LONG KHANH COMMUNE",
    "LONG PHU THUAN COMMUNE",
    "LONG TIEN COMMUNE",
    "LONG DINH COMMUNE",
    "LUONG HOA LAC COMMUNE",
    "LAP VO COMMUNE",
    "MY AN HUNG COMMUNE",
    "MY HIEP COMMUNE",
    "MY LOI COMMUNE",
    "MY QUI COMMUNE",
    "MY THIEN COMMUNE",
    "MY THANH COMMUNE",
    "MY THO COMMUNE",
    "MY TINH AN COMMUNE",
    "MY DUC TAY COMMUNE",
    "NGU HIEP COMMUNE",
    "PHONG HOA COMMUNE",
    "PHONG MY COMMUNE",
    "PHU CUONG COMMUNE",
    "PHU HUU COMMUNE",
    "PHU THANH COMMUNE",
    "PHU THO COMMUNE",
    "PHUONG THINH COMMUNE",
    "TAM NONG COMMUNE",
    "THANH BINH COMMUNE",
    "THANH HUNG COMMUNE",
    "THANH MY COMMUNE",
    "THAP MUOI COMMUNE",
    "THUONG PHUOC COMMUNE",
    "THANH PHU COMMUNE",
    "TRAM CHIM COMMUNE",
    "TRUONG XUAN COMMUNE",
    "TAN DUONG COMMUNE",
    "TAN HOA COMMUNE",
    "TAN HUONG COMMUNE",
    "TAN HONG COMMUNE",
    "TAN HO CO COMMUNE",
    "TAN KHANH TRUNG COMMUNE",
    "TAN LONG COMMUNE",
    "TAN NHUAN DONG COMMUNE",
    "TAN PHU COMMUNE",
    "TAN PHU TRUNG COMMUNE",
    "TAN PHU DONG COMMUNE",
    "TAN PHUOC 1 COMMUNE",
    "TAN PHUOC 2 COMMUNE",
    "TAN PHUOC 3 COMMUNE",
    "TAN THUAN BINH COMMUNE",
    "TAN THANH COMMUNE",
    "TAN THOI COMMUNE",
    "TAN DIEN COMMUNE",
    "TAN DONG COMMUNE",
    "VINH BINH COMMUNE",
    "VINH HUU COMMUNE",
    "VINH KIM COMMUNE",
    "DOC BINH KIEU COMMUNE",
    "DONG SON COMMUNE"
  ]
}